var _path, _path2, _path3, _polygon, _polygon2, _path4, _polygon3, _polygon4, _polygon5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevops2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--SVGID--inject-2",
    d: "M348.28,238.32h0l-3.53-4h0l.42.47.43.5.46.51.46.53.46.53.45.51.44.5Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--svgid--inject-2",
    d: "M345.53,234.93l3.53,4a4,4,0,0,1-.2,5l-3.53-4A4,4,0,0,0,345.53,234.93Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--svgid--inject-2",
    d: "M295.24,308.69l-3.53-4a3,3,0,0,0,.77.64c1.83,1.05,4.54.24,6-1.8l3.53,4c-1.51,2-4.22,2.85-6.05,1.8A3.21,3.21,0,0,1,295.24,308.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409,255.09c-88.41-51-231.28-51-319.12,0S2.55,388.9,91,439.94s231.28,51.05,319.12,0S497.45,306.14,409,255.09Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.42,399.94c-20.27-11.71-53-11.71-73.17,0s-20,30.68.23,42.38,53,11.71,73.18,0S382.69,411.64,362.42,399.94Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.96 400.56 90.02 408.07 361.1 250.85 348.04 243.34 76.96 400.56",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.58,439.34c-6.31-3.65-16.52-3.65-22.8,0s-6.24,9.56.08,13.21,16.52,3.64,22.8,0S230.9,443,224.58,439.34Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.51,418.35l-15.29.45-15.3-.45c-.65,10.33,1.36,20.86,4.14,26h0a7,7,0,0,0,3,3.08c4.51,2.6,11.81,2.6,16.29,0a6.82,6.82,0,0,0,3-3.16C227.18,439.1,229.17,428.63,228.51,418.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,412.09c6,3.46,6,9.07.07,12.53s-15.64,3.46-21.63,0-6-9.07-.07-12.53S218,408.63,224,412.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.63,413.46c4.67,2.7,4.7,7.08.05,9.78s-12.2,2.7-16.87,0-4.7-7.08-.06-9.78S217,410.76,221.63,413.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.63,413.46c4.67,2.7,4.7,7.08.05,9.78s-12.2,2.7-16.87,0-4.7-7.08-.06-9.78S217,410.76,221.63,413.46Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M238.37,353.08c-34.47,11.29-34.78,34.35-27,50.77,2,3.32,7.89,5.11,13-15.31l-9,1.16,10.55-5.35,2.74-8.19-8.8.65L231,372.12A164.51,164.51,0,0,1,238.37,353.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.37,353.08c-34.47,11.29-34.78,34.35-27,50.77,2,3.32,7.89,5.11,13-15.31l-9,1.16,10.55-5.35,2.74-8.19-8.8.65L231,372.12A164.51,164.51,0,0,1,238.37,353.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.37,353.08c-34.47,11.29-34.78,34.35-27,50.77,2,3.32,7.89,5.11,13-15.31l-9,1.16,10.55-5.35,2.74-8.19-8.8.65L231,372.12A164.51,164.51,0,0,1,238.37,353.08Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.62,358.85c-18.18,13.8-19.82,29.61-14.68,46.12C212.12,390.44,210.16,375.73,228.62,358.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,376.51c34,4.78,38.09,26.21,33.59,42.79-1.28,3.42-6.5,6.07-14.7-12.09l8.62-.43-10.71-3.22-3.92-7.18,8.3-.85L190,393A155.93,155.93,0,0,0,180,376.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,376.51c34,4.78,38.09,26.21,33.59,42.79-1.28,3.42-6.5,6.07-14.7-12.09l8.62-.43-10.71-3.22-3.92-7.18,8.3-.85L190,393A155.93,155.93,0,0,0,180,376.51Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,376.51c34,4.78,38.09,26.21,33.59,42.79-1.28,3.42-6.5,6.07-14.7-12.09l8.62-.43-10.71-3.22-3.92-7.18,8.3-.85L190,393A155.93,155.93,0,0,0,180,376.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,380.26c19.22,9.83,23.38,24.28,21.34,40.52C210.64,406.93,210,392.92,190,380.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.31,384.54c-31.16.51-37.27,19.35-35.06,34.81.76,3.22,5.18,6.19,14.6-9.26l-7.73-1.35,10-1.71,4.33-6-7.38-1.7,10.35-1A141.57,141.57,0,0,1,248.31,384.54Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.84,386.79c-18.42,6.71-23.78,19.28-23.76,34.13C217.28,408.53,219.4,396,238.84,386.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.31,384.54c-31.16.51-37.27,19.35-35.06,34.81.76,3.22,5.18,6.19,14.6-9.26l-7.73-1.35,10-1.71,4.33-6-7.38-1.7,10.35-1A141.57,141.57,0,0,1,248.31,384.54Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.75,232.9l.2.19Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.21,231.64c-.17-.08-.35-.17-.54-.28l-.56-.35-.18-.13-.37-.28-.2-.17-.33-.29a1.8,1.8,0,0,1-.2-.19l-.25-.25-.39-.41L444,229l-.23-.28-.27-.34c0-.08-.11-.15-.16-.22l-.29-.43-.12-.17c-.13-.2-.25-.4-.37-.6l-.06-.11c-.1-.17-.19-.35-.28-.53l-.1-.18c-.09-.19-.18-.38-.26-.57a.25.25,0,0,1,0-.07c-.09-.22-.18-.43-.26-.65,0-.07,0-.13-.07-.2s-.11-.31-.16-.47-.05-.16-.07-.24l-.12-.42c0-.11-.05-.21-.07-.31l-.06-.32c0-.16-.06-.31-.08-.47s0-.28-.05-.42l0-.21c0-.22,0-.44,0-.65a7.08,7.08,0,0,1,0-.82,6.51,6.51,0,0,1,.8.39,13,13,0,0,1,5.89,10.19c0,.29,0,.56-.06.82l-.12,0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.89,220.76l-.16.15Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.78,234.73Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.86,233.83l.18.13Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.25,220.46c-.06,0-.13.08-.18.13S437.19,220.51,437.25,220.46Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.9,222.6a1.41,1.41,0,0,0-.06.22A1.41,1.41,0,0,1,435.9,222.6Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.78,223.23a1.52,1.52,0,0,0,0,.21A1.52,1.52,0,0,1,435.78,223.23Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.29,221.55a2,2,0,0,1-.11.2A2,2,0,0,0,436.29,221.55Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.07,222l-.09.22Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.57,221.12l-.14.18Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.91,211.74h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.54,217.4l-.14-.16h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.11,232.24l.39.41Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.46,211.74h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.38,227.63a1.59,1.59,0,0,0,.07.2A1.59,1.59,0,0,1,436.38,227.63Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.17,229.35h0l-.12-.44h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.89,216.72l-.21-.21h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.52,230.84c0-.21-.09-.41-.13-.61h0C453.43,230.43,453.48,230.63,453.52,230.84Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.44,235.11h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.93,230.71h0a1.63,1.63,0,0,1-.11-.17h0A1.63,1.63,0,0,0,437.93,230.71Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.45,229.94h0l-.06-.11h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.4,234.91l-.11,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.1,229.3l-.09-.18.09.18Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,226.49h0c0-.1,0-.2-.07-.3h0C436,226.29,436,226.39,436,226.49Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.76,225a8.24,8.24,0,0,1-.05-.85c0,.21,0,.43,0,.65C435.75,224.84,435.75,224.91,435.76,225Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.74,228.55h0l0-.07h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.89,225.87h0c0-.16-.06-.31-.08-.47h0C435.83,225.56,435.86,225.71,435.89,225.87Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.22,227.16c0-.08-.05-.16-.08-.24,0,.08.05.16.08.24Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.39,231.36h0l-.17-.23h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.48,235l-.24,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,235.11l-.18,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,235l-.1,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,234.92l-.41-.15h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.49,233.55l.19.14c-.19-.14-.39-.3-.58-.47l.19.16Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.28,234.66a7.31,7.31,0,0,1-.68-.35,4.63,4.63,0,0,0,.54.28Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.89,232h0l-.23-.28h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.8,243.29l.48.6-4.56,2.65.95-3.56A8.44,8.44,0,0,0,447.8,243.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.73,217.1l-3.57-1,4.57-2.66.31.81A8.6,8.6,0,0,0,429.73,217.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.78,223.23a2.9,2.9,0,0,1,.06-.41,1.41,1.41,0,0,1,.06-.22,3.38,3.38,0,0,1,.08-.34l.09-.22c0-.09.07-.2.11-.29a2,2,0,0,0,.11-.2l.14-.25.14-.18.16-.21.16-.15a1.45,1.45,0,0,1,.18-.17c.05-.05.12-.08.18-.13a3.66,3.66,0,0,1,3.59-.11,7.08,7.08,0,0,0,0,.82c0,.21,0,.43,0,.65l0,.21c0,.14,0,.28.05.42s.05.31.08.47l.06.32c0,.1.05.2.07.31l.12.42c0,.08,0,.16.07.24s.1.32.16.47.05.13.07.2c.08.22.17.43.26.65a.25.25,0,0,0,0,.07c.08.19.17.38.26.57l.1.18c.09.18.18.36.28.53l.06.11c.12.2.24.4.37.6l.12.17.29.43c.05.07.11.14.16.22l.27.34.23.28.23.26.39.41.25.25a1.8,1.8,0,0,0,.2.19l.33.29.2.17.37.28.18.13.56.35c.19.11.37.2.54.28l.14.07.12,0a3.74,3.74,0,0,1-1.69,3h0a2.64,2.64,0,0,1-.38.18l-.09,0h0L445,235l-.09,0h0a3.15,3.15,0,0,1-.43.05H444l-.17,0h0l-.31-.05-.23,0h0l-.26-.07-.41-.15h0l-.29-.11-.14-.07a4.63,4.63,0,0,1-.54-.28L441,234l-.18-.13-.18-.14-.19-.14-.2-.17-.19-.16-.15-.13-.2-.19-.25-.25-.39-.41-.22-.26h0l-.23-.28h0l-.27-.34h0l-.16-.23h0c-.1-.13-.19-.28-.29-.42h0a1.63,1.63,0,0,1-.11-.17h0c-.13-.2-.26-.4-.37-.6h0l-.06-.11h0c-.1-.17-.2-.35-.29-.53h0l-.09-.18-.27-.57h0l0-.07h0c-.1-.22-.18-.44-.26-.65a1.59,1.59,0,0,1-.07-.2c-.06-.15-.11-.31-.16-.47h0c0-.08-.05-.16-.08-.24s-.07-.28-.11-.43h0c0-.1,0-.2-.07-.3h0c0-.11,0-.21-.07-.32h0c0-.16-.06-.31-.08-.47h0c0-.14,0-.28-.05-.43s0-.13,0-.2c0-.22,0-.44,0-.65s0-.46,0-.68A1.52,1.52,0,0,1,435.78,223.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.93 238.62 457.08 238.93 457.58 238.63 459.12 242.58 454.05 245.53 452.19 240.79 455.93 238.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.24 209.55 435.44 211.76 432.25 207.77 437.32 204.82 440.03 208.21 439.51 208.51 439.24 209.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.5,238l2.43.67-3.74,2.17A8.18,8.18,0,0,0,453.5,238Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.56,212.07a9,9,0,0,0-2.1-.33h-1l3.8-2.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.39,230.23h0c-.07-.29-.14-.59-.22-.88h0l-.12-.44h0a25.37,25.37,0,0,0-.82-2.41l5.08-2.95.09.22c0,.13.08.25.13.37s.16.43.23.65c0,0,0,.09.05.14s.06.21.1.31.15.48.22.72l.06.2.06.24c.08.29.15.59.21.88,0,.09.05.18.07.26s.05.23.07.35l-5.08,3C453.48,230.63,453.43,230.43,453.39,230.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.87,218.94c-.43-.54-.87-1.05-1.33-1.54l-.14-.16h0l-.51-.52-.21-.21h0q-.45-.45-.93-.87l5.08-2.95q.46.42.93.87a.6.6,0,0,0,.08.08l.42.43.22.22.7.78,0,0c.25.29.5.59.74.9h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.52 230.84 458.6 227.89 462.17 231.03 457.09 233.98 453.52 230.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.09 233.98 462.17 231.03 462.15 235.98 457.58 238.63 457.08 238.93 457.09 233.98",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.82 211 448.9 208.05 449.83 212.69 444.75 215.64 443.82 211",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.51 208.51 440.03 208.21 444.59 205.56 448.9 208.05 443.82 211 439.51 208.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.11 223.9 459.18 220.95 457.31 223.55 452.24 226.5 454.11 223.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.87 218.94 452.94 215.99 452.94 215.99 456.15 215.69 451.07 218.64 447.87 218.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.07 218.64 456.15 215.69 459.18 220.95 454.11 223.9 451.07 218.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,228.55l-1.87,2.6,3,5.26,3.21-.29a26.35,26.35,0,0,0,3.11,3.29l.93,4.64,4.31,2.49.95-3.56a8.44,8.44,0,0,0,3.13.31l.48.6,2.71,3.38,3.06-1.74-1.86-4.74A8.18,8.18,0,0,0,453.5,238l2.43.67,1.15.31v-5l-3.57-3.14c0-.21-.09-.41-.13-.61s-.14-.59-.22-.88l-.12-.44a25.37,25.37,0,0,0-.82-2.41l1.88-2.6-3-5.26-3.2.3c-.43-.54-.87-1.05-1.33-1.54l-.14-.16-.51-.52-.21-.21q-.45-.45-.93-.87l-.93-4.64-4.31-2.49-.27,1-.68,2.52a9,9,0,0,0-2.1-.33h-1l-3.19-4-3.06,1.74,1.54,4,.31.81a8.6,8.6,0,0,0-1.31,2.83l-3.57-1,0,4.95,3.57,3.15A26.34,26.34,0,0,0,431,228.55Zm4.71-4.43c0-.24,0-.46,0-.68a1.52,1.52,0,0,1,0-.21,2.9,2.9,0,0,1,.06-.41,1.41,1.41,0,0,1,.06-.22,3.38,3.38,0,0,1,.08-.34l.09-.22c0-.09.07-.2.11-.29a2,2,0,0,0,.11-.2l.14-.25.14-.18.16-.21.16-.15a1.45,1.45,0,0,1,.18-.17c.05-.05.12-.08.18-.13a3.66,3.66,0,0,1,3.59-.11,6.51,6.51,0,0,1,.8.39,13,13,0,0,1,5.89,10.19c0,.29,0,.56-.06.82a3.74,3.74,0,0,1-1.69,3h0a2.64,2.64,0,0,1-.38.18l-.11,0L445,235l-.1,0a3.15,3.15,0,0,1-.43.05H444l-.18,0-.31-.05-.24,0-.26-.07-.41-.15-.29-.11a7.31,7.31,0,0,1-.68-.35L441,234l-.18-.13-.18-.14c-.19-.14-.39-.3-.58-.47l-.15-.13-.2-.19-.25-.25-.39-.41-.22-.26-.23-.28-.27-.34-.17-.23c-.1-.13-.19-.28-.29-.42a1.63,1.63,0,0,1-.11-.17c-.13-.2-.26-.4-.37-.6l-.06-.11c-.1-.17-.2-.35-.29-.53l-.09-.18-.27-.57,0-.07c-.1-.22-.18-.44-.26-.65a1.59,1.59,0,0,1-.07-.2c-.06-.15-.11-.31-.16-.47s-.05-.16-.08-.24-.07-.28-.11-.43,0-.2-.07-.3,0-.21-.07-.32-.06-.31-.08-.47,0-.28-.05-.43A8.24,8.24,0,0,1,435.71,224.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.8,243.29l.48.6-4.56,2.65.95-3.56A8.44,8.44,0,0,0,447.8,243.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.73,217.1l-3.57-1,4.57-2.66.31.81A8.6,8.6,0,0,0,429.73,217.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.78,223.23a2.9,2.9,0,0,1,.06-.41,1.41,1.41,0,0,1,.06-.22,3.38,3.38,0,0,1,.08-.34l.09-.22c0-.09.07-.2.11-.29a2,2,0,0,0,.11-.2l.14-.25.14-.18.16-.21.16-.15a1.45,1.45,0,0,1,.18-.17c.05-.05.12-.08.18-.13a3.66,3.66,0,0,1,3.59-.11,7.08,7.08,0,0,0,0,.82c0,.21,0,.43,0,.65l0,.21c0,.14,0,.28.05.42s.05.31.08.47l.06.32c0,.1.05.2.07.31l.12.42c0,.08,0,.16.07.24s.1.32.16.47.05.13.07.2c.08.22.17.43.26.65a.25.25,0,0,0,0,.07c.08.19.17.38.26.57l.1.18c.09.18.18.36.28.53l.06.11c.12.2.24.4.37.6l.12.17.29.43c.05.07.11.14.16.22l.27.34.23.28.23.26.39.41.25.25a1.8,1.8,0,0,0,.2.19l.33.29.2.17.37.28.18.13.56.35c.19.11.37.2.54.28l.14.07.12,0a3.74,3.74,0,0,1-1.69,3h0a2.64,2.64,0,0,1-.38.18l-.09,0h0L445,235l-.09,0h0a3.15,3.15,0,0,1-.43.05H444l-.17,0h0l-.31-.05-.23,0h0l-.26-.07-.41-.15h0l-.29-.11-.14-.07a4.63,4.63,0,0,1-.54-.28L441,234l-.18-.13-.18-.14-.19-.14-.2-.17-.19-.16-.15-.13-.2-.19-.25-.25-.39-.41-.22-.26h0l-.23-.28h0l-.27-.34h0l-.16-.23h0c-.1-.13-.19-.28-.29-.42h0a1.63,1.63,0,0,1-.11-.17h0c-.13-.2-.26-.4-.37-.6h0l-.06-.11h0c-.1-.17-.2-.35-.29-.53h0l-.09-.18-.27-.57h0l0-.07h0c-.1-.22-.18-.44-.26-.65a1.59,1.59,0,0,1-.07-.2c-.06-.15-.11-.31-.16-.47h0c0-.08-.05-.16-.08-.24s-.07-.28-.11-.43h0c0-.1,0-.2-.07-.3h0c0-.11,0-.21-.07-.32h0c0-.16-.06-.31-.08-.47h0c0-.14,0-.28-.05-.43s0-.13,0-.2c0-.22,0-.44,0-.65s0-.46,0-.68A1.52,1.52,0,0,1,435.78,223.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.93 238.62 457.08 238.93 457.58 238.63 459.12 242.58 454.05 245.53 452.19 240.79 455.93 238.62",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.5,238l2.43.67-3.74,2.17A8.18,8.18,0,0,0,453.5,238Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.56,212.07a9,9,0,0,0-2.1-.33h-1l3.8-2.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.39,230.23h0c-.07-.29-.14-.59-.22-.88h0l-.12-.44h0a25.37,25.37,0,0,0-.82-2.41l5.08-2.95.09.22c0,.13.08.25.13.37s.16.43.23.65c0,0,0,.09.05.14s.06.21.1.31.15.48.22.72l.06.2.06.24c.08.29.15.59.21.88,0,.09.05.18.07.26s.05.23.07.35l-5.08,3C453.48,230.63,453.43,230.43,453.39,230.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.09 233.98 462.17 231.03 462.15 235.98 457.58 238.63 457.08 238.93 457.09 233.98",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.82 211 448.9 208.05 449.83 212.69 444.75 215.64 443.82 211",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.11 223.9 459.18 220.95 457.31 223.55 452.24 226.5 454.11 223.9",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.87 218.94 452.94 215.99 452.94 215.99 456.15 215.69 451.07 218.64 447.87 218.94",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.24 209.55 435.44 211.76 432.25 207.77 437.32 204.82 440.03 208.21 439.51 208.51 439.24 209.55",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.87,218.94c-.43-.54-.87-1.05-1.33-1.54l-.14-.16h0l-.51-.52-.21-.21h0q-.45-.45-.93-.87l5.08-2.95q.46.42.93.87a.6.6,0,0,0,.08.08l.42.43.22.22.7.78,0,0c.25.29.5.59.74.9h0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.52 230.84 458.6 227.89 462.17 231.03 457.09 233.98 453.52 230.84",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.51 208.51 440.03 208.21 444.59 205.56 448.9 208.05 443.82 211 439.51 208.51",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.07 218.64 456.15 215.69 459.18 220.95 454.11 223.9 451.07 218.64",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.27,200.53l.14.13Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.55,199.64a3.48,3.48,0,0,1-.38-.2,3.34,3.34,0,0,1-.4-.25l-.13-.09-.26-.2-.14-.12-.24-.2a.86.86,0,0,0-.14-.13l-.17-.18a4,4,0,0,1-.28-.3l-.16-.18a1.56,1.56,0,0,1-.16-.2l-.19-.24-.12-.15-.21-.3a.83.83,0,0,0-.08-.12l-.26-.43s0,0,0-.08l-.2-.37a.83.83,0,0,1-.07-.13l-.19-.4,0-.06c-.07-.15-.13-.3-.19-.45a.58.58,0,0,0,0-.14c0-.11-.07-.22-.11-.34a.84.84,0,0,1-.05-.17c0-.1-.06-.2-.08-.3a1.6,1.6,0,0,1-.05-.21c0-.08,0-.15-.05-.23l-.06-.33,0-.3c0-.05,0-.1,0-.15a3.53,3.53,0,0,1,0-.46,5.49,5.49,0,0,1,0-.58,6,6,0,0,1,.57.28,9.18,9.18,0,0,1,4.16,7.21,5.28,5.28,0,0,1,0,.58l-.08,0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.24,191.94l-.11.11Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.53,201.83h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.05,201.19l.13.09Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.5,191.73l-.13.09Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.54,193.24c0,.06,0,.11,0,.16S405.53,193.3,405.54,193.24Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.46,193.69a.77.77,0,0,0,0,.15A.77.77,0,0,1,405.46,193.69Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.82,192.5c0,.05-.05.09-.07.14S405.8,192.55,405.82,192.5Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.67,192.85a.94.94,0,0,0-.06.15A.94.94,0,0,1,405.67,192.85Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,192.2a1.47,1.47,0,0,0-.1.13A1.47,1.47,0,0,1,406,192.2Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.55,185.56h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.08,189.56a.52.52,0,0,1-.1-.11h0A.52.52,0,0,0,413.08,189.56Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.82,200.06l.28.3Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.94,185.56h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.88,196.8a1.21,1.21,0,0,1,.05.14A1.21,1.21,0,0,0,405.88,196.8Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77,198h0l-.09-.31h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.62,189.09l-.15-.15h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,199.07c0-.14-.06-.28-.09-.43h0C418,198.79,418,198.93,418,199.07Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.59,202.1h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,199h0l-.08-.12h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.64,198.43h0l0-.07h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.27,202l-.08,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.4,198a.75.75,0,0,1-.07-.12.75.75,0,0,0,.07.12Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.64,196h0a1.6,1.6,0,0,1-.05-.21h0A1.6,1.6,0,0,0,405.64,196Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.45,194.92c0-.2,0-.4,0-.6,0,.15,0,.3,0,.46S405.44,194.87,405.45,194.92Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.14,197.45h0s0,0,0-.06h0A.08.08,0,0,0,406.14,197.45Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.54,195.56h0l-.06-.34h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.77,196.47a1.09,1.09,0,0,1,0-.17,1.54,1.54,0,0,0,0,.17Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.31,199.44h0l-.12-.16h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.91,202l-.17,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.26,202.09h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,202l-.07,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.56,202l-.3-.11h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.79,201l.14.1a4.23,4.23,0,0,1-.41-.33l.13.11Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.06,201.77l-.48-.24.38.2Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.66,199.88h0l-.16-.2h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,207.88l.33.43-3.22,1.87.67-2.52A6,6,0,0,0,414,207.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.18,189.35l-2.52-.69,3.23-1.88.22.57A6.06,6.06,0,0,0,401.18,189.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.46,193.69a2.54,2.54,0,0,1,0-.29c0-.05,0-.1,0-.16a2.17,2.17,0,0,1,.07-.24.94.94,0,0,1,.06-.15,1.8,1.8,0,0,1,.08-.21s.05-.09.07-.14l.1-.17a1.47,1.47,0,0,1,.1-.13l.11-.15.11-.11.13-.12.13-.09a2.59,2.59,0,0,1,2.54-.08,5.49,5.49,0,0,0,0,.58,3.53,3.53,0,0,0,0,.46c0,.05,0,.1,0,.15l0,.3.06.33c0,.08,0,.15.05.23a1.6,1.6,0,0,0,.05.21c0,.1,0,.2.08.3a.84.84,0,0,0,.05.17c0,.12.07.23.11.34a.58.58,0,0,1,0,.14c.06.15.12.3.19.45l0,.06.19.4a.83.83,0,0,0,.07.13l.2.37s0,0,0,.08l.26.43a.83.83,0,0,1,.08.12l.21.3.12.15.19.24a1.56,1.56,0,0,0,.16.2l.16.18a4,4,0,0,0,.28.3l.17.18a.86.86,0,0,1,.14.13l.24.2.14.12.26.2.13.09a3.34,3.34,0,0,0,.4.25,3.48,3.48,0,0,0,.38.2l.1.05.08,0a2.67,2.67,0,0,1-1.19,2.11h0a1.23,1.23,0,0,1-.26.12l-.07,0h0a1.55,1.55,0,0,1-.23.06l-.06,0h0l-.3,0h-.46l-.22,0-.17,0h0l-.18,0-.3-.1h0l-.2-.08-.1,0-.38-.2-.4-.25-.13-.09-.12-.1-.14-.1-.14-.12-.13-.11-.11-.1-.14-.13a1.37,1.37,0,0,1-.17-.17l-.28-.3-.16-.18h0l-.16-.2h0l-.19-.24h0l-.12-.16h0L407,199h0l-.08-.12h0c-.09-.14-.18-.28-.26-.43h0l0-.07h0c-.07-.12-.14-.25-.2-.38h0a.75.75,0,0,1-.07-.12l-.19-.4h0a.08.08,0,0,1,0,0h0c-.07-.15-.13-.3-.19-.46a1.21,1.21,0,0,0-.05-.14c0-.11-.07-.22-.11-.33h0a1.54,1.54,0,0,1,0-.17c0-.1-.06-.2-.08-.3h0a1.6,1.6,0,0,1-.05-.21h0c0-.08,0-.16,0-.23h0l-.06-.34h0l0-.3s0-.09,0-.14,0-.31,0-.46,0-.33,0-.48A.77.77,0,0,1,405.46,193.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.72 204.57 420.53 204.79 420.88 204.59 421.97 207.38 418.38 209.47 417.07 206.11 419.72 204.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.91 184.01 405.22 185.57 402.96 182.75 406.55 180.67 408.47 183.06 408.1 183.28 407.91 184.01",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,204.11l1.72.46-2.65,1.54A5.87,5.87,0,0,0,418,204.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.43,185.79a6.75,6.75,0,0,0-1.49-.23h-.72l2.69-1.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.92,198.64h0l-.15-.62h0l-.09-.31h0a16.41,16.41,0,0,0-.58-1.71l3.59-2.08.06.16a2,2,0,0,1,.1.26l.16.45,0,.1.06.22c.06.17.11.34.16.51s0,.1,0,.14,0,.12.05.17l.15.63c0,.06,0,.12,0,.18a2,2,0,0,1,.05.24L418,199.07C418,198.93,418,198.79,417.92,198.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,190.65c-.3-.38-.61-.74-.93-1.09a.52.52,0,0,1-.1-.11h0l-.36-.36-.15-.15h0c-.22-.22-.44-.42-.66-.62l3.59-2.08c.22.19.44.4.66.61l.06.05.29.31.16.16.5.55h0c.18.21.36.42.53.64h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.01 199.07 421.6 196.98 424.13 199.21 420.54 201.29 418.01 199.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.54 201.29 424.13 199.21 424.12 202.71 420.88 204.59 420.53 204.79 420.54 201.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.15 185.03 414.74 182.95 415.4 186.24 411.81 188.32 411.15 185.03",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.1 183.28 408.47 183.06 411.69 181.19 414.74 182.95 411.15 185.03 408.1 183.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.43 194.16 422.02 192.08 420.69 193.92 417.1 196 418.43 194.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.01 190.65 417.61 188.57 417.61 188.57 419.87 188.36 416.28 190.44 414.01 190.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,207.88l.33.43-3.22,1.87.67-2.52A6,6,0,0,0,414,207.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.18,189.35l-2.52-.69,3.23-1.88.22.57A6.06,6.06,0,0,0,401.18,189.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.46,193.69a2.54,2.54,0,0,1,0-.29c0-.05,0-.1,0-.16a2.17,2.17,0,0,1,.07-.24.94.94,0,0,1,.06-.15,1.8,1.8,0,0,1,.08-.21s.05-.09.07-.14l.1-.17a1.47,1.47,0,0,1,.1-.13l.11-.15.11-.11.13-.12.13-.09a2.59,2.59,0,0,1,2.54-.08,5.49,5.49,0,0,0,0,.58,3.53,3.53,0,0,0,0,.46c0,.05,0,.1,0,.15l0,.3.06.33c0,.08,0,.15.05.23a1.6,1.6,0,0,0,.05.21c0,.1,0,.2.08.3a.84.84,0,0,0,.05.17c0,.12.07.23.11.34a.58.58,0,0,1,0,.14c.06.15.12.3.19.45l0,.06.19.4a.83.83,0,0,0,.07.13l.2.37s0,0,0,.08l.26.43a.83.83,0,0,1,.08.12l.21.3.12.15.19.24a1.56,1.56,0,0,0,.16.2l.16.18a4,4,0,0,0,.28.3l.17.18a.86.86,0,0,1,.14.13l.24.2.14.12.26.2.13.09a3.34,3.34,0,0,0,.4.25,3.48,3.48,0,0,0,.38.2l.1.05.08,0a2.67,2.67,0,0,1-1.19,2.11h0a1.23,1.23,0,0,1-.26.12l-.07,0h0a1.55,1.55,0,0,1-.23.06l-.06,0h0l-.3,0h-.46l-.22,0-.17,0h0l-.18,0-.3-.1h0l-.2-.08-.1,0-.38-.2-.4-.25-.13-.09-.12-.1-.14-.1-.14-.12-.13-.11-.11-.1-.14-.13a1.37,1.37,0,0,1-.17-.17l-.28-.3-.16-.18h0l-.16-.2h0l-.19-.24h0l-.12-.16h0L407,199h0l-.08-.12h0c-.09-.14-.18-.28-.26-.43h0l0-.07h0c-.07-.12-.14-.25-.2-.38h0a.75.75,0,0,1-.07-.12l-.19-.4h0a.08.08,0,0,1,0,0h0c-.07-.15-.13-.3-.19-.46a1.21,1.21,0,0,0-.05-.14c0-.11-.07-.22-.11-.33h0a1.54,1.54,0,0,1,0-.17c0-.1-.06-.2-.08-.3h0a1.6,1.6,0,0,1-.05-.21h0c0-.08,0-.16,0-.23h0l-.06-.34h0l0-.3s0-.09,0-.14,0-.31,0-.46,0-.33,0-.48A.77.77,0,0,1,405.46,193.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.72 204.57 420.53 204.79 420.88 204.59 421.97 207.38 418.38 209.47 417.07 206.11 419.72 204.57",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,204.11l1.72.46-2.65,1.54A5.87,5.87,0,0,0,418,204.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.43,185.79a6.75,6.75,0,0,0-1.49-.23h-.72l2.69-1.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.92,198.64h0l-.15-.62h0l-.09-.31h0a16.41,16.41,0,0,0-.58-1.71l3.59-2.08.06.16a2,2,0,0,1,.1.26l.16.45,0,.1.06.22c.06.17.11.34.16.51s0,.1,0,.14,0,.12.05.17l.15.63c0,.06,0,.12,0,.18a2,2,0,0,1,.05.24L418,199.07C418,198.93,418,198.79,417.92,198.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.54 201.29 424.13 199.21 424.12 202.71 420.88 204.59 420.53 204.79 420.54 201.29",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.15 185.03 414.74 182.95 415.4 186.24 411.81 188.32 411.15 185.03",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.43 194.16 422.02 192.08 420.69 193.92 417.1 196 418.43 194.16",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.01 190.65 417.61 188.57 417.61 188.57 419.87 188.36 416.28 190.44 414.01 190.65",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.28 190.44 419.87 188.36 422.02 192.08 418.43 194.16 416.28 190.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.91 184.01 405.22 185.57 402.96 182.75 406.55 180.67 408.47 183.06 408.1 183.28 407.91 184.01",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,190.65c-.3-.38-.61-.74-.93-1.09a.52.52,0,0,1-.1-.11h0l-.36-.36-.15-.15h0c-.22-.22-.44-.42-.66-.62l3.59-2.08c.22.19.44.4.66.61l.06.05.29.31.16.16.5.55h0c.18.21.36.42.53.64h0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.01 199.07 421.6 196.98 424.13 199.21 420.54 201.29 418.01 199.07",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.1 183.28 408.47 183.06 411.69 181.19 414.74 182.95 411.15 185.03 408.1 183.28",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.28 190.44 419.87 188.36 422.02 192.08 418.43 194.16 416.28 190.44",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.08,197.45l-1.32,1.84L402.9,203l2.27-.2a18,18,0,0,0,2.2,2.32l.66,3.29,3.05,1.76.67-2.52a6,6,0,0,0,2.22.22l.33.43,1.92,2.39,2.16-1.23-1.31-3.36a5.87,5.87,0,0,0,.93-2l1.72.46.81.22v-3.5L418,199.07c0-.14-.06-.28-.09-.43l-.15-.62-.09-.31a16.41,16.41,0,0,0-.58-1.71l1.33-1.84-2.15-3.72-2.27.21c-.3-.38-.61-.74-.93-1.09a.52.52,0,0,1-.1-.11l-.36-.36-.15-.15c-.22-.22-.44-.42-.66-.62l-.66-3.29-3-1.75-.19.73-.48,1.78a6.75,6.75,0,0,0-1.49-.23h-.72L403,182.76,400.8,184l1.09,2.79.22.57a6.06,6.06,0,0,0-.93,2l-2.52-.69v3.5l2.52,2.23A17.5,17.5,0,0,0,402.08,197.45Zm3.33-3.13c0-.17,0-.33,0-.48a.77.77,0,0,1,0-.15,2.54,2.54,0,0,1,0-.29c0-.05,0-.1,0-.16a2.17,2.17,0,0,1,.07-.24.94.94,0,0,1,.06-.15,1.8,1.8,0,0,1,.08-.21s.05-.09.07-.14l.1-.17a1.47,1.47,0,0,1,.1-.13l.11-.15.11-.11.13-.12.13-.09a2.59,2.59,0,0,1,2.54-.08,6,6,0,0,1,.57.28,9.18,9.18,0,0,1,4.16,7.21,5.28,5.28,0,0,1,0,.58,2.67,2.67,0,0,1-1.19,2.11h0a1.23,1.23,0,0,1-.26.12l-.08,0a1.55,1.55,0,0,1-.23.06l-.07,0-.3,0h-.46l-.22,0-.17,0-.18,0-.3-.11-.2-.08-.48-.24-.4-.25-.13-.09-.12-.1a4.23,4.23,0,0,1-.41-.33l-.11-.1-.14-.13a1.37,1.37,0,0,1-.17-.17l-.28-.3-.16-.18-.16-.2-.19-.24-.12-.16L407,199l-.08-.12c-.09-.14-.18-.28-.26-.43l0-.07c-.07-.12-.14-.25-.2-.38a.75.75,0,0,1-.07-.12l-.19-.4s0,0,0-.06-.13-.3-.19-.46a1.21,1.21,0,0,0-.05-.14c0-.11-.07-.22-.11-.33a1.09,1.09,0,0,1,0-.17c0-.1-.06-.2-.08-.3a1.6,1.6,0,0,1-.05-.21c0-.08,0-.16,0-.23l-.06-.34,0-.3C405.43,194.72,405.41,194.52,405.41,194.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,188a1.14,1.14,0,0,0,.11.11A1.14,1.14,0,0,1,437,188Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.18,187.31l-.31-.15-.31-.2-.1-.08-.21-.16-.12-.09-.18-.16-.12-.11-.14-.14-.22-.23-.12-.15a1,1,0,0,1-.13-.16l-.15-.19-.1-.12-.16-.24-.07-.1-.21-.34,0-.06-.16-.3a.93.93,0,0,1,0-.1l-.15-.32,0,0-.15-.37s0-.07,0-.11l-.09-.26s0-.1,0-.14l-.06-.24-.05-.17,0-.18c0-.09,0-.18-.05-.27l0-.23a.49.49,0,0,0,0-.12c0-.13,0-.25,0-.37a3.44,3.44,0,0,1,0-.46,3.71,3.71,0,0,1,.45.22,7.32,7.32,0,0,1,3.31,5.75,3.44,3.44,0,0,1,0,.46l-.06,0A.2.2,0,0,1,441.18,187.31Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.36,181.18l-.09.09Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.37,189.05Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.6,188.54l.1.08Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.56,181l-.1.07Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.8,182.22l0,.12Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.73,182.58s0,.07,0,.11S434.73,182.62,434.73,182.58Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,181.63l-.07.11Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.9,181.91l0,.12Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.18,181.39l-.08.1Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.81,176.1h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.8,179.29l-.08-.09h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.61,187.65l.22.23Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.12,176.1h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.07,185.05s0,.08,0,.11S435.08,185.09,435.07,185.05Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.54,186h0a1.82,1.82,0,0,1-.07-.25h0A1.82,1.82,0,0,0,444.54,186Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.43,178.91l-.11-.12h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.73,186.86c0-.11-.05-.23-.07-.34h0C444.68,186.63,444.71,186.75,444.73,186.86Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.61,189.27h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,186.79h0l-.07-.1h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.67,186.35h0l0-.06h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.16,189.15l-.06,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.48,186a.93.93,0,0,1-.05-.1.93.93,0,0,0,.05.1Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.88,184.41h0a.85.85,0,0,1,0-.17h0A.85.85,0,0,0,434.88,184.41Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.73,183.56a4.15,4.15,0,0,1,0-.49c0,.12,0,.25,0,.37S434.72,183.52,434.73,183.56Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.28,185.57h0l0,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.8,184.06h0c0-.09,0-.18-.05-.26h0C434.77,183.88,434.78,184,434.8,184.06Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,184.79s0-.09,0-.14,0,.09,0,.14Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.21,187.15h0l-.1-.12h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.08,189.23l-.14,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.35,189.27l-.1,0h.1Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.91,189.23h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.79,189.16l-.23-.08h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.39,188.39l.11.08a3.92,3.92,0,0,1-.33-.27l.11.09Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.4,189a3.49,3.49,0,0,1-.39-.19l.31.16Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.49,187.5h0l-.13-.15h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.51,193.88l.27.33-2.57,1.5.54-2A4.74,4.74,0,0,0,441.51,193.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.33,179.12l-2-.55,2.57-1.5.18.45A4.73,4.73,0,0,0,431.33,179.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.73,182.58a2,2,0,0,1,0-.24l0-.12c0-.07,0-.13.05-.19l0-.12.06-.17.07-.11.07-.14.08-.1.09-.12.09-.09.1-.09.1-.07a2.06,2.06,0,0,1,2-.07,3.44,3.44,0,0,0,0,.46c0,.12,0,.24,0,.37a.49.49,0,0,1,0,.12l0,.23c0,.09,0,.18.05.27l0,.18.05.17.06.24s0,.09,0,.14l.09.26s0,.08,0,.11l.15.37,0,0,.15.32a.93.93,0,0,0,0,.1l.16.3,0,.06.21.34.07.1.16.24.1.12.15.19a1,1,0,0,0,.13.16l.12.15.22.23.14.14.12.11.18.16.12.09.21.16.1.08.31.2.31.15a.2.2,0,0,0,.08,0l.06,0a2.08,2.08,0,0,1-.95,1.67h0a1,1,0,0,1-.21.1l-.05,0h0l-.19,0h-.05l-.25,0h-.36l-.17,0-.14,0h0l-.15,0-.23-.08h0l-.16-.07-.08,0-.31-.16-.31-.2-.1-.08-.1-.07-.11-.08-.11-.1-.11-.09-.08-.07A1.14,1.14,0,0,1,437,188l-.15-.14-.22-.23-.12-.15h0l-.13-.15h0l-.15-.2h0l-.1-.12h0l-.16-.24h0l-.07-.1h0l-.21-.34h0l0-.06h0l-.16-.3h0a.93.93,0,0,1-.05-.1l-.15-.32h0l0,0h0l-.15-.37s0-.07,0-.11l-.09-.26h0s0-.09,0-.14l-.06-.24h0a.85.85,0,0,1,0-.17h0a1.16,1.16,0,0,1,0-.18h0c0-.09,0-.18-.05-.26h0a1.94,1.94,0,0,1,0-.24s0-.08,0-.12,0-.25,0-.37,0-.25,0-.38S434.73,182.62,434.73,182.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.09 191.24 446.74 191.42 447.02 191.25 447.89 193.48 445.03 195.14 443.99 192.47 446.09 191.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.68 174.87 434.54 176.11 432.75 173.87 435.6 172.2 437.13 174.11 436.84 174.28 436.68 174.87",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.72,190.87l1.37.37L444,192.47A4.54,4.54,0,0,0,444.72,190.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.3,176.28a5,5,0,0,0-1.18-.18h-.58l2.14-1.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.66,186.52h0l-.12-.5h0a1.82,1.82,0,0,1-.07-.25h0c-.13-.45-.28-.9-.46-1.35l2.86-1.66a.61.61,0,0,0,.05.12c0,.07.05.14.07.21s.09.24.13.36l0,.08c0,.06,0,.12.05.18s.09.27.13.4l0,.12a.65.65,0,0,0,0,.13l.12.5,0,.14a1.42,1.42,0,0,1,0,.2l-2.86,1.66C444.71,186.75,444.68,186.63,444.66,186.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.55,180.16c-.24-.31-.49-.59-.75-.87l-.08-.09h0l-.29-.29-.11-.12h0l-.53-.49,2.86-1.66c.18.15.35.32.52.49a.1.1,0,0,1,.05,0l.24.24.12.13c.14.14.27.29.4.44h0l.42.5h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.73 186.86 447.59 185.2 449.6 186.97 446.74 188.63 444.73 186.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.74 188.63 449.6 186.97 449.6 189.76 447.02 191.25 446.74 191.42 446.74 188.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.27 175.68 442.13 174.02 442.65 176.64 439.79 178.3 439.27 175.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.84 174.28 437.13 174.11 439.7 172.62 442.13 174.02 439.27 175.68 436.84 174.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.06 182.95 447.92 181.29 446.87 182.76 444.01 184.42 445.06 182.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.55 180.16 444.41 178.49 444.41 178.49 446.21 178.33 443.35 179.99 441.55 180.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.51,193.88l.27.33-2.57,1.5.54-2A4.74,4.74,0,0,0,441.51,193.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.33,179.12l-2-.55,2.57-1.5.18.45A4.73,4.73,0,0,0,431.33,179.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.73,182.58a2,2,0,0,1,0-.24l0-.12c0-.07,0-.13.05-.19l0-.12.06-.17.07-.11.07-.14.08-.1.09-.12.09-.09.1-.09.1-.07a2.06,2.06,0,0,1,2-.07,3.44,3.44,0,0,0,0,.46c0,.12,0,.24,0,.37a.49.49,0,0,1,0,.12l0,.23c0,.09,0,.18.05.27l0,.18.05.17.06.24s0,.09,0,.14l.09.26s0,.08,0,.11l.15.37,0,0,.15.32a.93.93,0,0,0,0,.1l.16.3,0,.06.21.34.07.1.16.24.1.12.15.19a1,1,0,0,0,.13.16l.12.15.22.23.14.14.12.11.18.16.12.09.21.16.1.08.31.2.31.15a.2.2,0,0,0,.08,0l.06,0a2.08,2.08,0,0,1-.95,1.67h0a1,1,0,0,1-.21.1l-.05,0h0l-.19,0h-.05l-.25,0h-.36l-.17,0-.14,0h0l-.15,0-.23-.08h0l-.16-.07-.08,0-.31-.16-.31-.2-.1-.08-.1-.07-.11-.08-.11-.1-.11-.09-.08-.07A1.14,1.14,0,0,1,437,188l-.15-.14-.22-.23-.12-.15h0l-.13-.15h0l-.15-.2h0l-.1-.12h0l-.16-.24h0l-.07-.1h0l-.21-.34h0l0-.06h0l-.16-.3h0a.93.93,0,0,1-.05-.1l-.15-.32h0l0,0h0l-.15-.37s0-.07,0-.11l-.09-.26h0s0-.09,0-.14l-.06-.24h0a.85.85,0,0,1,0-.17h0a1.16,1.16,0,0,1,0-.18h0c0-.09,0-.18-.05-.26h0a1.94,1.94,0,0,1,0-.24s0-.08,0-.12,0-.25,0-.37,0-.25,0-.38S434.73,182.62,434.73,182.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.09 191.24 446.74 191.42 447.02 191.25 447.89 193.48 445.03 195.14 443.99 192.47 446.09 191.24",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.72,190.87l1.37.37L444,192.47A4.54,4.54,0,0,0,444.72,190.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.3,176.28a5,5,0,0,0-1.18-.18h-.58l2.14-1.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.66,186.52h0l-.12-.5h0a1.82,1.82,0,0,1-.07-.25h0c-.13-.45-.28-.9-.46-1.35l2.86-1.66a.61.61,0,0,0,.05.12c0,.07.05.14.07.21s.09.24.13.36l0,.08c0,.06,0,.12.05.18s.09.27.13.4l0,.12a.65.65,0,0,0,0,.13l.12.5,0,.14a1.42,1.42,0,0,1,0,.2l-2.86,1.66C444.71,186.75,444.68,186.63,444.66,186.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.74 188.63 449.6 186.97 449.6 189.76 447.02 191.25 446.74 191.42 446.74 188.63",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.27 175.68 442.13 174.02 442.65 176.64 439.79 178.3 439.27 175.68",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.06 182.95 447.92 181.29 446.87 182.76 444.01 184.42 445.06 182.95",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.55 180.16 444.41 178.49 444.41 178.49 446.21 178.33 443.35 179.99 441.55 180.16",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.35 179.99 446.21 178.33 447.92 181.29 445.06 182.95 443.35 179.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.68 174.87 434.54 176.11 432.75 173.87 435.6 172.2 437.13 174.11 436.84 174.28 436.68 174.87",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.55,180.16c-.24-.31-.49-.59-.75-.87l-.08-.09h0l-.29-.29-.11-.12h0l-.53-.49,2.86-1.66c.18.15.35.32.52.49a.1.1,0,0,1,.05,0l.24.24.12.13c.14.14.27.29.4.44h0l.42.5h0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.73 186.86 447.59 185.2 449.6 186.97 446.74 188.63 444.73 186.86",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.84 174.28 437.13 174.11 439.7 172.62 442.13 174.02 439.27 175.68 436.84 174.28",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.35 179.99 446.21 178.33 447.92 181.29 445.06 182.95 443.35 179.99",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,185.57,431,187l1.71,3,1.8-.16a15.51,15.51,0,0,0,1.76,1.85l.52,2.62,2.43,1.4.54-2a4.74,4.74,0,0,0,1.76.18l.27.33,1.53,1.91,1.72-1-1-2.67a4.54,4.54,0,0,0,.74-1.6l1.37.37.65.18v-2.79l-2-1.77c0-.11-.05-.23-.07-.34l-.12-.5a1.82,1.82,0,0,1-.07-.25c-.13-.45-.28-.9-.46-1.35l1.05-1.47-1.71-3-1.8.17c-.24-.31-.49-.59-.75-.87l-.08-.09-.29-.29-.11-.12-.53-.49-.52-2.62-2.43-1.4-.16.59-.38,1.41a5,5,0,0,0-1.18-.18h-.58l-1.8-2.24-1.72,1,.87,2.22.18.45a4.73,4.73,0,0,0-.74,1.6l-2-.55v2.79l2,1.77A15,15,0,0,0,432,185.57Zm2.66-2.5c0-.13,0-.25,0-.38s0-.07,0-.11a2,2,0,0,1,0-.24l0-.12c0-.07,0-.13.05-.19l0-.12.06-.17.07-.11.07-.14.08-.1.09-.12.09-.09.1-.09.1-.07a2.06,2.06,0,0,1,2-.07,3.71,3.71,0,0,1,.45.22,7.32,7.32,0,0,1,3.31,5.75,3.44,3.44,0,0,1,0,.46,2.08,2.08,0,0,1-.95,1.67h0a1,1,0,0,1-.21.1l-.06,0-.19,0h-.05l-.25,0h-.26l-.1,0-.17,0-.14,0-.15,0-.23-.08-.16-.07a3.49,3.49,0,0,1-.39-.19l-.31-.2-.1-.08-.1-.07a3.92,3.92,0,0,1-.33-.27l-.08-.07A1.14,1.14,0,0,1,437,188l-.15-.14-.22-.23-.12-.15-.13-.15-.15-.2-.1-.12-.16-.24-.07-.1-.21-.34,0-.06-.16-.3a.93.93,0,0,1-.05-.1l-.15-.32,0,0-.15-.37s0-.07,0-.11l-.09-.26s0-.09,0-.14l-.06-.24a.85.85,0,0,1,0-.17,1.16,1.16,0,0,1,0-.18c0-.09,0-.18-.05-.26a1.94,1.94,0,0,1,0-.24A4.15,4.15,0,0,1,434.7,183.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,157.64l-.27.24Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.93,156l.73-.38.75-.48.24-.17.5-.38.27-.22.45-.39.27-.25.33-.34c.18-.18.36-.37.53-.56l.3-.34.31-.38.36-.46.22-.3q.19-.27.39-.57l.16-.22c.17-.27.34-.54.5-.82l.08-.14c.13-.23.26-.47.38-.71l.12-.24c.13-.25.25-.51.36-.77l0-.1c.12-.29.24-.58.35-.87l.09-.26c.08-.21.15-.42.22-.64l.09-.32c.06-.19.11-.38.16-.57s.07-.27.1-.4.05-.29.08-.44.08-.42.11-.63,0-.38.07-.57l0-.28q0-.44,0-.87a9.54,9.54,0,0,0-.07-1.1,9.64,9.64,0,0,0-1.07.53c-4.37,2.52-7.92,8.66-7.9,13.68a9.54,9.54,0,0,0,.07,1.1l.16-.06Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8,141.34a2,2,0,0,1,.21.2A2,2,0,0,0,96.8,141.34Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.86,160.09Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.47,158.88l-.24.17Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.32,140.94l.24.16Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.13,143.8c0,.1.06.2.08.3C98.19,144,98.16,143.9,98.13,143.8Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.29,144.65c0,.1,0,.19,0,.28C98.32,144.84,98.3,144.75,98.29,144.65Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6,142.4c.05.09.1.17.14.26C97.7,142.57,97.65,142.49,97.6,142.4Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9,143.06a2.33,2.33,0,0,1,.11.28A2.33,2.33,0,0,0,97.9,143.06Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.23,141.82l.18.24Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.11,129.22l.46,0-.46,0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.83,136.82l.19-.21h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.81,156.74l-.52.56Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.37,129.22h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.49,150.56a2.77,2.77,0,0,1-.1.26A2.77,2.77,0,0,0,97.49,150.56Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.93,152.87h0c.06-.2.11-.4.17-.59h0C75,152.47,75,152.67,74.93,152.87Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.71,135.91l.28-.28h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.46,154.86c.05-.27.12-.54.18-.81h0C74.58,154.32,74.51,154.59,74.46,154.86Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.66,160.6h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4,154.69h0l.15-.22h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.05,153.65h0s0-.09.08-.14h0C96.1,153.56,96.08,153.61,96.05,153.65Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.37,160.33l.14,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.51,152.8l.12-.24-.12.24Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,149h0l.1-.4h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.31,147a9,9,0,0,0,.06-1.15,8.43,8.43,0,0,1,0,.87Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,151.8h0a.54.54,0,0,0,.05-.11h0A.54.54,0,0,1,97,151.8Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.13,148.19h0c.05-.21.08-.42.11-.63h0C98.21,147.77,98.18,148,98.13,148.19Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7,149.93c0-.11.07-.22.1-.33,0,.11-.07.22-.1.33Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.78,155.56h0l.22-.3h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.94,160.51l.33-.07h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.29,160.59l.24,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,160.5a.5.5,0,0,0,.13,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.61,160.34l.57-.19h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,158.5l-.26.2a9.46,9.46,0,0,0,.78-.64l-.25.22A3.2,3.2,0,0,1,92,158.5Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.56,160a7.77,7.77,0,0,0,.91-.46c-.24.14-.48.26-.72.38Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.12,156.4h0l.3-.38h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.14,171.59l-.64.8L87.62,176l-1.28-4.78A11.32,11.32,0,0,1,82.14,171.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.41,136.42l4.79-1.32-6.13-3.56-.42,1.07A11.56,11.56,0,0,1,106.41,136.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.29,144.65c0-.18-.05-.37-.08-.55s0-.2-.08-.3-.07-.31-.12-.46a2.33,2.33,0,0,0-.11-.28c-.05-.14-.1-.27-.16-.4s-.09-.17-.14-.26a3.72,3.72,0,0,0-.19-.34l-.18-.24c-.07-.09-.14-.19-.22-.28a2,2,0,0,0-.21-.2c-.08-.08-.16-.17-.24-.24l-.24-.16a4.91,4.91,0,0,0-4.83-.16,9.54,9.54,0,0,1,.07,1.1q0,.44,0,.87l0,.28c0,.19,0,.38-.07.57s-.07.42-.11.63,0,.29-.08.44-.07.27-.1.4-.1.38-.16.57l-.09.32c-.07.22-.14.43-.22.64l-.09.26c-.11.29-.23.58-.35.87l0,.1c-.11.26-.23.52-.36.77l-.12.24c-.12.24-.25.48-.38.71l-.08.14c-.16.28-.33.55-.5.82l-.16.22q-.19.3-.39.57l-.22.3-.36.46-.31.38-.3.34c-.17.19-.35.38-.53.56l-.33.34-.27.25-.45.39-.27.22-.5.38-.24.17-.75.48-.73.38-.18.08-.16.06a5,5,0,0,0,2.27,4h0a3,3,0,0,0,.51.24l.12,0h0a3.17,3.17,0,0,0,.44.12l.11,0h0a3.68,3.68,0,0,0,.58.07h.14a4.1,4.1,0,0,0,.49,0l.22,0h0l.41-.06.32-.07h0l.34-.1.56-.19h0l.38-.16.19-.08c.24-.12.48-.24.72-.38s.51-.31.76-.48l.24-.17.23-.18.26-.2a3.2,3.2,0,0,0,.27-.22l.25-.22a1.71,1.71,0,0,0,.2-.18l.27-.24c.11-.11.22-.23.34-.34l.52-.56.31-.34h0l.3-.38h0a5.19,5.19,0,0,0,.36-.46h0l.22-.3h0c.14-.18.27-.37.4-.57h0l.15-.22h0c.17-.27.34-.54.5-.82h0s0-.09.08-.14h0c.13-.23.26-.47.38-.71h0l.12-.24c.13-.25.25-.51.36-.76h0a.54.54,0,0,0,.05-.11h0c.13-.29.24-.58.35-.87a2.77,2.77,0,0,0,.1-.26l.21-.63h0c0-.11.07-.22.1-.33L98,149h0l.1-.4h0c0-.15.06-.29.08-.44h0c.05-.21.08-.42.11-.63h0c0-.19.05-.38.07-.57l0-.28a8.43,8.43,0,0,0,0-.87,8.84,8.84,0,0,0,0-.91C98.32,144.84,98.3,144.75,98.29,144.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.23 165.31 69.69 165.73 69.01 165.33 66.95 170.64 73.76 174.6 76.25 168.22 71.23 165.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.65 126.28 98.75 129.25 103.03 123.89 96.22 119.94 92.58 124.48 93.27 124.88 93.65 126.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.49,164.42l-3.26.89,5,2.91A11.11,11.11,0,0,1,74.49,164.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.55,129.66a12.11,12.11,0,0,1,2.82-.44h.74l.46,0h.17l-5.09-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.64,154.05h0c.09-.39.19-.79.29-1.18h0c.06-.2.11-.4.16-.59h0c.31-1.08.67-2.16,1.09-3.24l-6.81-4-.12.3-.18.5c-.1.28-.21.57-.31.86l-.06.19c0,.14-.09.28-.13.42-.11.32-.21.64-.3,1a2.76,2.76,0,0,0-.08.27c0,.1,0,.21-.08.32-.11.39-.2.79-.29,1.18l-.09.35-.09.46,6.81,4C74.51,154.59,74.58,154.32,74.64,154.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.05,138.89c.57-.72,1.17-1.41,1.78-2.07l.19-.21h0l.69-.7.28-.28h0c.41-.41.83-.8,1.25-1.17l-6.82-4c-.42.37-.83.76-1.24,1.17l-.12.1-.56.58-.29.3c-.32.34-.64.69-.95,1l0,0c-.34.39-.67.79-1,1.21h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.46 154.86 67.65 150.9 62.86 155.12 69.67 159.08 74.46 154.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.67 159.08 62.86 155.12 62.88 161.77 69.01 165.33 69.69 165.73 69.67 159.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.49 128.22 80.67 124.26 79.42 130.5 86.24 134.46 87.49 128.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.27 124.88 92.58 124.48 86.46 120.92 80.67 124.26 87.49 128.22 93.27 124.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.68 145.55 66.86 141.59 69.38 145.08 76.19 149.04 73.68 145.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.05 138.88 75.24 134.93 75.24 134.93 70.94 134.53 77.75 138.49 82.05 138.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.75 138.49 70.94 134.53 66.86 141.59 73.68 145.55 77.75 138.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.43,146l4.79-4.22,0-6.65-4.79,1.32a11.56,11.56,0,0,0-1.76-3.81l.42-1.07,2.07-5.31L103,123.89l-4.29,5.36h-.17l-.46,0h-.74a12.11,12.11,0,0,0-2.82.44l-.9-3.38-.38-1.4-5.78,3.34-1.25,6.24c-.42.37-.84.76-1.25,1.17l-.28.28-.69.7-.19.21c-.61.66-1.21,1.35-1.78,2.07l-4.3-.4-4.07,7.06L76.19,149c-.42,1.08-.78,2.16-1.09,3.24-.06.19-.11.39-.17.59-.1.39-.2.79-.29,1.18s-.13.54-.18.81l-4.79,4.22,0,6.65,1.54-.42,3.26-.89a11.11,11.11,0,0,0,1.76,3.8l-2.49,6.38,4.1,2.33,3.64-4.54.64-.8a11.32,11.32,0,0,0,4.2-.42L87.62,176l5.79-3.34,1.25-6.24A34.53,34.53,0,0,0,98.84,162l4.3.39,4.08-7.06-2.52-3.49A33.54,33.54,0,0,0,106.43,146Zm-8.12,1c0,.19,0,.38-.07.57s-.06.42-.11.63,0,.29-.08.44l-.1.4-.15.57c0,.11-.07.22-.1.33l-.21.63a2.77,2.77,0,0,1-.1.26c-.11.29-.22.58-.35.87a.54.54,0,0,1-.05.11c-.11.25-.23.51-.36.76l-.12.24c-.12.24-.25.48-.38.71,0,.05,0,.1-.08.14-.16.28-.33.55-.5.82l-.15.22c-.13.2-.26.39-.4.57l-.22.3a5.19,5.19,0,0,1-.36.46l-.3.38-.31.34-.52.56c-.12.11-.23.23-.34.34l-.27.24a1.71,1.71,0,0,1-.2.18,9.46,9.46,0,0,1-.78.64l-.23.18-.24.17c-.25.17-.5.33-.76.48a7.77,7.77,0,0,1-.91.46l-.38.16-.57.19-.34.1-.33.07-.41.06-.24,0a4.1,4.1,0,0,1-.49,0h-.14a3.68,3.68,0,0,1-.58-.07.5.5,0,0,1-.13,0,3.17,3.17,0,0,1-.44-.12l-.14,0a3,3,0,0,1-.51-.24h0a5,5,0,0,1-2.27-4,9.54,9.54,0,0,1-.07-1.1c0-5,3.53-11.16,7.9-13.68a9.64,9.64,0,0,1,1.07-.53,4.91,4.91,0,0,1,4.83.16l.24.16c.08.07.16.16.24.24a2,2,0,0,1,.21.2c.08.09.15.19.22.28l.18.24a3.72,3.72,0,0,1,.19.34c.05.09.1.17.14.26s.11.26.16.4a2.33,2.33,0,0,1,.11.28c0,.15.08.3.12.46s.06.2.08.3.06.37.08.55,0,.19,0,.28a8.84,8.84,0,0,1,0,.91A9,9,0,0,1,98.31,147Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.14,171.59l-.64.8L87.62,176l-1.28-4.78A11.32,11.32,0,0,1,82.14,171.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.41,136.42l4.79-1.32-6.13-3.56-.42,1.07A11.56,11.56,0,0,1,106.41,136.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.29,144.65c0-.18-.05-.37-.08-.55s0-.2-.08-.3-.07-.31-.12-.46a2.33,2.33,0,0,0-.11-.28c-.05-.14-.1-.27-.16-.4s-.09-.17-.14-.26a3.72,3.72,0,0,0-.19-.34l-.18-.24c-.07-.09-.14-.19-.22-.28a2,2,0,0,0-.21-.2c-.08-.08-.16-.17-.24-.24l-.24-.16a4.91,4.91,0,0,0-4.83-.16,9.54,9.54,0,0,1,.07,1.1q0,.44,0,.87l0,.28c0,.19,0,.38-.07.57s-.07.42-.11.63,0,.29-.08.44-.07.27-.1.4-.1.38-.16.57l-.09.32c-.07.22-.14.43-.22.64l-.09.26c-.11.29-.23.58-.35.87l0,.1c-.11.26-.23.52-.36.77l-.12.24c-.12.24-.25.48-.38.71l-.08.14c-.16.28-.33.55-.5.82l-.16.22q-.19.3-.39.57l-.22.3-.36.46-.31.38-.3.34c-.17.19-.35.38-.53.56l-.33.34-.27.25-.45.39-.27.22-.5.38-.24.17-.75.48-.73.38-.18.08-.16.06a5,5,0,0,0,2.27,4h0a3,3,0,0,0,.51.24l.12,0h0a3.17,3.17,0,0,0,.44.12l.11,0h0a3.68,3.68,0,0,0,.58.07h.14a4.1,4.1,0,0,0,.49,0l.22,0h0l.41-.06.32-.07h0l.34-.1.56-.19h0l.38-.16.19-.08c.24-.12.48-.24.72-.38s.51-.31.76-.48l.24-.17.23-.18.26-.2a3.2,3.2,0,0,0,.27-.22l.25-.22a1.71,1.71,0,0,0,.2-.18l.27-.24c.11-.11.22-.23.34-.34l.52-.56.31-.34h0l.3-.38h0a5.19,5.19,0,0,0,.36-.46h0l.22-.3h0c.14-.18.27-.37.4-.57h0l.15-.22h0c.17-.27.34-.54.5-.82h0s0-.09.08-.14h0c.13-.23.26-.47.38-.71h0l.12-.24c.13-.25.25-.51.36-.76h0a.54.54,0,0,0,.05-.11h0c.13-.29.24-.58.35-.87a2.77,2.77,0,0,0,.1-.26l.21-.63h0c0-.11.07-.22.1-.33L98,149h0l.1-.4h0c0-.15.06-.29.08-.44h0c.05-.21.08-.42.11-.63h0c0-.19.05-.38.07-.57l0-.28a8.43,8.43,0,0,0,0-.87,8.84,8.84,0,0,0,0-.91C98.32,144.84,98.3,144.75,98.29,144.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.23 165.31 69.69 165.73 69.01 165.33 66.95 170.64 73.76 174.6 76.25 168.22 71.23 165.31",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.49,164.42l-3.26.89,5,2.91A11.11,11.11,0,0,1,74.49,164.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.55,129.66a12.11,12.11,0,0,1,2.82-.44h.74l.46,0h.17l-5.09-3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.64,154.05h0c.09-.39.19-.79.29-1.18h0c.06-.2.11-.4.16-.59h0c.31-1.08.67-2.16,1.09-3.24l-6.81-4-.12.3-.18.5c-.1.28-.21.57-.31.86l-.06.19c0,.14-.09.28-.13.42-.11.32-.21.64-.3,1a2.76,2.76,0,0,0-.08.27c0,.1,0,.21-.08.32-.11.39-.2.79-.29,1.18l-.09.35-.09.46,6.81,4C74.51,154.59,74.58,154.32,74.64,154.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.67 159.08 62.86 155.12 62.88 161.77 69.01 165.33 69.69 165.73 69.67 159.08",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.49 128.22 80.67 124.26 79.42 130.5 86.24 134.46 87.49 128.22",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.68 145.55 66.86 141.59 69.38 145.08 76.19 149.04 73.68 145.55",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.05 138.88 75.24 134.93 75.24 134.93 70.94 134.53 77.75 138.49 82.05 138.88",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.65 126.28 98.75 129.25 103.03 123.89 96.22 119.94 92.58 124.48 93.27 124.88 93.65 126.28",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.05,138.89c.57-.72,1.17-1.41,1.78-2.07l.19-.21h0l.69-.7.28-.28h0c.41-.41.83-.8,1.25-1.17l-6.82-4c-.42.37-.83.76-1.24,1.17l-.12.1-.56.58-.29.3c-.32.34-.64.69-.95,1l0,0c-.34.39-.67.79-1,1.21h0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.46 154.86 67.65 150.9 62.86 155.12 69.67 159.08 74.46 154.86",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.27 124.88 92.58 124.48 86.46 120.92 80.67 124.26 87.49 128.22 93.27 124.88",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.75 138.49 70.94 134.53 66.86 141.59 73.68 145.55 77.75 138.49",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.81,201.56l-.13.12Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,200.74l.35-.18.36-.23.12-.09.24-.18.13-.11.22-.19.13-.12.16-.16.26-.27a2.09,2.09,0,0,1,.14-.17l.15-.18.17-.22.11-.15.19-.27a1,1,0,0,1,.08-.11l.24-.4,0-.07.18-.34.06-.11.18-.38,0,0c.06-.14.12-.29.17-.43l0-.12c0-.1.07-.21.11-.31s0-.11,0-.16.05-.18.08-.27a1.46,1.46,0,0,1,0-.2,1.55,1.55,0,0,1,0-.21c0-.1,0-.2,0-.3l0-.28s0-.09,0-.14,0-.28,0-.42a4.45,4.45,0,0,0,0-.53,4.89,4.89,0,0,0-.52.25,8.47,8.47,0,0,0-3.82,6.63,4.45,4.45,0,0,0,0,.53l.08,0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.67,193.67a.94.94,0,0,1,.1.1A.94.94,0,0,0,78.67,193.67Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.89,202.75Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.09,202.16l-.12.08Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.44,193.48l.11.08Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.31,194.86a.83.83,0,0,1,0,.15A.83.83,0,0,0,79.31,194.86Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.39,195.28a.51.51,0,0,1,0,.13A.51.51,0,0,0,79.39,195.28Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.06,194.18a.54.54,0,0,0,.07.13A.54.54,0,0,1,79.06,194.18Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2,194.5l.06.14Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.88,193.9A.83.83,0,0,1,79,194,.83.83,0,0,0,78.88,193.9Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3,187.8h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.39,191.48l.09-.1h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.22,201.12c-.08.1-.17.19-.25.28C77.05,201.31,77.14,201.22,77.22,201.12Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,187.8h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,198.13c0,.05,0,.09,0,.13S79,198.18,79,198.13Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.09,199.25h0c0-.1,0-.19.07-.29h0C68.14,199.06,68.11,199.15,68.09,199.25Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.82,191l.13-.13h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.86,200.21c0-.13.06-.26.08-.39h0C67.92,200,67.88,200.08,67.86,200.21Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.76,203h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,200.13h0a.41.41,0,0,0,.07-.11h0A.41.41,0,0,1,78,200.13Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.31,199.63h0l0-.07h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.14,202.86l.07,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.53,199.22l.06-.12-.06.12Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.23,197.39h0c0-.06,0-.13,0-.19h0C79.26,197.26,79.24,197.33,79.23,197.39Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4,196.41a5.4,5.4,0,0,0,0-.56c0,.14,0,.28,0,.42A.66.66,0,0,1,79.4,196.41Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.76,198.73h0l0,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.32,197h0c0-.1,0-.21.05-.31h0C79.35,196.78,79.33,196.89,79.32,197Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1,197.83a1.42,1.42,0,0,0,.05-.16,1.42,1.42,0,0,1-.05.16Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.69,200.55h0a1.71,1.71,0,0,0,.11-.14h0A1.71,1.71,0,0,1,77.69,200.55Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.38,203l.16,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.06,203h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.42,203h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.71,202.87l.27-.1h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.33,202l-.13.09a3.68,3.68,0,0,0,.38-.31l-.12.11Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.17,202.7c.14-.07.29-.14.44-.23l-.35.19Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.37,201h0l.15-.18h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.58,208.31l-.31.39,3,1.72-.62-2.31A5.61,5.61,0,0,1,71.58,208.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.32,191.29l2.32-.64-3-1.72-.2.52A5.48,5.48,0,0,1,83.32,191.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.39,195.28a1.93,1.93,0,0,0,0-.27.83.83,0,0,0,0-.15c0-.07,0-.15,0-.22l-.06-.14-.07-.19a.54.54,0,0,1-.07-.13A1.4,1.4,0,0,0,79,194a.83.83,0,0,0-.08-.12l-.11-.13a.94.94,0,0,0-.1-.1l-.12-.11-.11-.08a2.36,2.36,0,0,0-2.34-.08,4.45,4.45,0,0,1,0,.53c0,.14,0,.28,0,.42s0,.1,0,.14l0,.28c0,.1,0,.2,0,.3a1.55,1.55,0,0,0,0,.21,1.46,1.46,0,0,0,0,.2c0,.09-.05.18-.08.27s0,.11,0,.16-.07.21-.11.31l0,.12c0,.14-.11.29-.17.43l0,0-.18.38-.06.11-.18.34,0,.07-.24.4a1,1,0,0,0-.08.11l-.19.27-.11.15-.17.22-.15.18a2.09,2.09,0,0,0-.14.17l-.26.27-.16.16-.13.12-.22.19-.13.11-.24.18-.12.09-.36.23-.35.18-.09,0-.08,0a2.45,2.45,0,0,0,1.1,1.94h0l.25.11,0,0h0l.21.06h.06a1.33,1.33,0,0,0,.28,0h.42l.2,0,.16,0h0l.17,0,.27-.1h0l.19-.07.09,0,.35-.19a3.61,3.61,0,0,0,.36-.23l.12-.08.11-.09.13-.09.13-.11.12-.11.1-.08.13-.12c0-.05.1-.11.16-.16s.17-.18.25-.28l.15-.16h0l.15-.18h0c.06-.08.12-.15.17-.23h0a1.71,1.71,0,0,0,.11-.14h0c.06-.09.13-.18.19-.28h0a.41.41,0,0,0,.07-.11h0c.09-.12.17-.26.25-.39h0l0-.07h0c.07-.11.13-.23.19-.34h0l.06-.12c.06-.12.12-.24.17-.37h0l0,0h0l.17-.42s0-.08,0-.13.07-.2.1-.3h0a1.42,1.42,0,0,0,.05-.16c0-.09,0-.18.08-.28h0c0-.06,0-.13,0-.19h0c0-.07,0-.14,0-.21h0c0-.1,0-.21.05-.31h0l0-.27a.66.66,0,0,0,0-.14c0-.14,0-.28,0-.42s0-.3,0-.44A.51.51,0,0,0,79.39,195.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.29 205.27 65.55 205.47 65.22 205.28 64.22 207.85 67.52 209.77 68.72 206.68 66.29 205.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.14 186.38 79.61 187.82 81.69 185.23 78.39 183.31 76.63 185.51 76.96 185.71 77.14 186.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.87,204.84l-1.58.43,2.43,1.41A5.39,5.39,0,0,1,67.87,204.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.58,188A6.2,6.2,0,0,1,79,187.8h.66l-2.47-1.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.94,199.82h0c0-.19.09-.38.15-.57h0c0-.1,0-.19.07-.29h0c.15-.52.33-1,.53-1.56l-3.29-1.92-.06.15-.09.24-.15.41,0,.1-.06.2c-.05.16-.1.31-.14.47a.5.5,0,0,0,0,.13.83.83,0,0,0,0,.15c-.05.19-.1.39-.14.58a.85.85,0,0,0,0,.17,1.42,1.42,0,0,0,0,.22l3.3,1.91C67.88,200.08,67.92,200,67.94,199.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.53,192.48c.28-.34.57-.68.86-1l.09-.1h0l.34-.34.13-.13h0c.2-.2.4-.39.61-.57l-3.3-1.91a8,8,0,0,0-.6.56l-.06,0-.27.28-.14.15c-.16.16-.31.33-.46.5h0c-.17.19-.33.39-.49.59h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.86 200.22 64.56 198.3 62.24 200.34 65.54 202.26 67.86 200.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.54 202.26 62.24 200.34 62.25 203.56 65.22 205.28 65.55 205.47 65.54 202.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.16 187.32 70.86 185.41 70.26 188.43 73.56 190.34 74.16 187.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.96 185.71 76.63 185.51 73.66 183.79 70.86 185.41 74.16 187.32 76.96 185.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.48 195.71 64.18 193.79 65.4 195.48 68.69 197.4 67.48 195.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.53 192.48 68.23 190.57 68.23 190.57 66.15 190.38 69.45 192.29 71.53 192.48",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.45 192.29 66.15 190.38 64.18 193.79 67.48 195.71 69.45 192.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.33,195.91l2.32-2v-3.22l-2.32.64a5.48,5.48,0,0,0-.85-1.84l.2-.52,1-2.57-2-1.13-2.08,2.59H79a6.2,6.2,0,0,0-1.37.22l-.44-1.64-.18-.67-2.8,1.61-.6,3c-.21.18-.41.37-.61.57l-.13.13-.34.34-.09.1c-.29.32-.58.66-.86,1l-2.08-.19-2,3.42,1.21,1.69c-.2.52-.38,1-.53,1.56,0,.1,0,.19-.07.29s-.1.38-.15.57-.06.26-.08.39l-2.32,2v3.21l.74-.2,1.58-.43a5.39,5.39,0,0,0,.85,1.84l-1.2,3.09,2,1.13,1.77-2.2.31-.39a5.61,5.61,0,0,0,2-.2l.62,2.31L77,208.8l.6-3a17.14,17.14,0,0,0,2-2.13l2.08.18,2-3.41-1.22-1.69A16.49,16.49,0,0,0,83.33,195.91Zm-3.93.5,0,.27c0,.1,0,.21-.05.31s0,.14,0,.21,0,.13,0,.19,0,.19-.08.28a1.42,1.42,0,0,1-.05.16c0,.1-.06.2-.1.3s0,.09,0,.13l-.17.42,0,0c-.05.13-.11.25-.17.37l-.06.12c-.06.11-.12.23-.19.34l0,.07c-.08.13-.16.27-.25.39a.41.41,0,0,1-.07.11c-.06.1-.13.19-.19.28a1.71,1.71,0,0,1-.11.14c0,.08-.11.15-.17.23l-.15.18-.15.16c-.08.1-.17.19-.25.28s-.11.11-.16.16l-.13.12-.1.08a3.68,3.68,0,0,1-.38.31l-.11.09-.12.08a3.61,3.61,0,0,1-.36.23c-.15.09-.3.16-.44.23l-.19.07-.27.1-.17,0-.16,0-.2,0h-.42a1.33,1.33,0,0,1-.28,0h-.06l-.21-.06-.07,0-.25-.11h0a2.45,2.45,0,0,1-1.1-1.94,4.45,4.45,0,0,1,0-.53,8.47,8.47,0,0,1,3.82-6.63,4.89,4.89,0,0,1,.52-.25,2.36,2.36,0,0,1,2.34.08l.11.08.12.11a.94.94,0,0,1,.1.1l.11.13A.83.83,0,0,1,79,194a1.4,1.4,0,0,1,.1.16.54.54,0,0,0,.07.13l.07.19.06.14c0,.07,0,.15,0,.22a.83.83,0,0,1,0,.15,1.93,1.93,0,0,1,0,.27.51.51,0,0,1,0,.13c0,.14,0,.29,0,.44A5.4,5.4,0,0,1,79.4,196.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.58,208.31l-.31.39,3,1.72-.62-2.31A5.61,5.61,0,0,1,71.58,208.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.32,191.29l2.32-.64-3-1.72-.2.52A5.48,5.48,0,0,1,83.32,191.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.39,195.28a1.93,1.93,0,0,0,0-.27.83.83,0,0,0,0-.15c0-.07,0-.15,0-.22l-.06-.14-.07-.19a.54.54,0,0,1-.07-.13A1.4,1.4,0,0,0,79,194a.83.83,0,0,0-.08-.12l-.11-.13a.94.94,0,0,0-.1-.1l-.12-.11-.11-.08a2.36,2.36,0,0,0-2.34-.08,4.45,4.45,0,0,1,0,.53c0,.14,0,.28,0,.42s0,.1,0,.14l0,.28c0,.1,0,.2,0,.3a1.55,1.55,0,0,0,0,.21,1.46,1.46,0,0,0,0,.2c0,.09-.05.18-.08.27s0,.11,0,.16-.07.21-.11.31l0,.12c0,.14-.11.29-.17.43l0,0-.18.38-.06.11-.18.34,0,.07-.24.4a1,1,0,0,0-.08.11l-.19.27-.11.15-.17.22-.15.18a2.09,2.09,0,0,0-.14.17l-.26.27-.16.16-.13.12-.22.19-.13.11-.24.18-.12.09-.36.23-.35.18-.09,0-.08,0a2.45,2.45,0,0,0,1.1,1.94h0l.25.11,0,0h0l.21.06h.06a1.33,1.33,0,0,0,.28,0h.42l.2,0,.16,0h0l.17,0,.27-.1h0l.19-.07.09,0,.35-.19a3.61,3.61,0,0,0,.36-.23l.12-.08.11-.09.13-.09.13-.11.12-.11.1-.08.13-.12c0-.05.1-.11.16-.16s.17-.18.25-.28l.15-.16h0l.15-.18h0c.06-.08.12-.15.17-.23h0a1.71,1.71,0,0,0,.11-.14h0c.06-.09.13-.18.19-.28h0a.41.41,0,0,0,.07-.11h0c.09-.12.17-.26.25-.39h0l0-.07h0c.07-.11.13-.23.19-.34h0l.06-.12c.06-.12.12-.24.17-.37h0l0,0h0l.17-.42s0-.08,0-.13.07-.2.1-.3h0a1.42,1.42,0,0,0,.05-.16c0-.09,0-.18.08-.28h0c0-.06,0-.13,0-.19h0c0-.07,0-.14,0-.21h0c0-.1,0-.21.05-.31h0l0-.27a.66.66,0,0,0,0-.14c0-.14,0-.28,0-.42s0-.3,0-.44A.51.51,0,0,0,79.39,195.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.29 205.27 65.55 205.47 65.22 205.28 64.22 207.85 67.52 209.77 68.72 206.68 66.29 205.27",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.87,204.84l-1.58.43,2.43,1.41A5.39,5.39,0,0,1,67.87,204.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.58,188A6.2,6.2,0,0,1,79,187.8h.66l-2.47-1.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.94,199.82h0c0-.19.09-.38.15-.57h0c0-.1,0-.19.07-.29h0c.15-.52.33-1,.53-1.56l-3.29-1.92-.06.15-.09.24-.15.41,0,.1-.06.2c-.05.16-.1.31-.14.47a.5.5,0,0,0,0,.13.83.83,0,0,0,0,.15c-.05.19-.1.39-.14.58a.85.85,0,0,0,0,.17,1.42,1.42,0,0,0,0,.22l3.3,1.91C67.88,200.08,67.92,200,67.94,199.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.54 202.26 62.24 200.34 62.25 203.56 65.22 205.28 65.55 205.47 65.54 202.26",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.16 187.32 70.86 185.41 70.26 188.43 73.56 190.34 74.16 187.32",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.48 195.71 64.18 193.79 65.4 195.48 68.69 197.4 67.48 195.71",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.53 192.48 68.23 190.57 68.23 190.57 66.15 190.38 69.45 192.29 71.53 192.48",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.14 186.38 79.61 187.82 81.69 185.23 78.39 183.31 76.63 185.51 76.96 185.71 77.14 186.38",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.53,192.48c.28-.34.57-.68.86-1l.09-.1h0l.34-.34.13-.13h0c.2-.2.4-.39.61-.57l-3.3-1.91a8,8,0,0,0-.6.56l-.06,0-.27.28-.14.15c-.16.16-.31.33-.46.5h0c-.17.19-.33.39-.49.59h0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.86 200.22 64.56 198.3 62.24 200.34 65.54 202.26 67.86 200.22",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.96 185.71 76.63 185.51 73.66 183.79 70.86 185.41 74.16 187.32 76.96 185.71",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.45 192.29 66.15 190.38 64.18 193.79 67.48 195.71 69.45 192.29",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.61,287.41l-.21.2Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.49,286c.2-.09.39-.19.59-.3s.41-.25.61-.39l.2-.14.4-.31.22-.18.36-.32.22-.2.27-.27.43-.45.24-.28c.09-.1.17-.21.25-.31s.2-.24.29-.37l.18-.24.32-.46c0-.06.09-.12.13-.19s.27-.43.4-.66l.07-.11c.1-.19.21-.38.31-.58l.09-.19c.11-.21.2-.41.3-.62l0-.08c.11-.24.2-.47.29-.71a1.72,1.72,0,0,0,.07-.21c.07-.17.12-.34.18-.52l.08-.26.12-.46c0-.11.06-.22.08-.33s0-.23.07-.35l.09-.51c0-.16,0-.31.05-.46l0-.23c0-.24,0-.48,0-.71a8.53,8.53,0,0,0,0-.89,7.78,7.78,0,0,0-.87.43,14.1,14.1,0,0,0-6.4,11.09,8.37,8.37,0,0,0,0,.89l.13-.05Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.73,274.2l.17.17Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.06,289.4h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.41,288.42a1.33,1.33,0,0,0-.19.14A1.33,1.33,0,0,1,79.41,288.42Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,273.88l.19.13Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.81,276.2l.06.24Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.94,276.89l0,.23Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.38,275.06l.12.22Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.62,275.6a1.57,1.57,0,0,1,.09.23A1.57,1.57,0,0,0,84.62,275.6Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.08,274.6a1.33,1.33,0,0,1,.14.19A1.33,1.33,0,0,0,84.08,274.6Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.79,264.38l.37,0-.37,0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.22,270.54l.16-.17h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.31,286.68c-.14.16-.28.31-.43.46C81,287,81.17,286.84,81.31,286.68Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.19,264.38h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.29,281.68l-.08.21Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,283.55h0c0-.16.09-.32.13-.48h0C66.1,283.23,66.05,283.39,66,283.55Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.93,269.81l.23-.24h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.63,285.16c0-.22.1-.44.14-.65h0C65.73,284.72,65.67,284.94,65.63,285.16Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.52,289.82h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.59,285h0l.13-.19h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.12,284.18h0l.07-.11h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.47,289.59l.11,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5,283.49a1.74,1.74,0,0,1,.1-.19,1.74,1.74,0,0,0-.1.19Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.66,280.44h0c0-.11.06-.22.08-.33h0C84.72,280.22,84.69,280.33,84.66,280.44Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,278.78c0-.31.05-.62.05-.93,0,.23,0,.47,0,.71A1.64,1.64,0,0,0,85,278.78Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.89,282.68h0a.36.36,0,0,1,0-.09h0A.36.36,0,0,0,83.89,282.68Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.81,279.76h0c0-.17.07-.34.09-.51h0C84.88,279.42,84.84,279.59,84.81,279.76Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.46,281.16l.08-.26-.08.26Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1,285.73h0l.17-.24h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.55,289.74l.27-.06h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,289.81l.2,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.94,289.73l.1,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1,289.6a4,4,0,0,0,.45-.16h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.81,288.11l-.21.16q.32-.24.63-.51l-.2.17Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,289.32a7.32,7.32,0,0,0,.73-.38,5.45,5.45,0,0,1-.58.31Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.56,286.41h0c.08-.1.16-.21.25-.31h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.85,298.72l-.51.65,5,2.88-1-3.87A9.32,9.32,0,0,1,71.85,298.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.52,270.22l3.88-1.07-5-2.89-.34.87A9.38,9.38,0,0,1,91.52,270.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.94,276.89c0-.15,0-.3-.07-.45l-.06-.24c0-.13-.06-.25-.1-.37a1.57,1.57,0,0,0-.09-.23l-.12-.32-.12-.22c0-.09-.1-.18-.16-.27a1.33,1.33,0,0,0-.14-.19,2,2,0,0,0-.18-.23l-.17-.17-.2-.19-.19-.13a4,4,0,0,0-3.91-.13,8.53,8.53,0,0,1,0,.89c0,.23,0,.47,0,.71l0,.23c0,.15,0,.3-.05.46l-.09.51c0,.12,0,.23-.07.35s0,.22-.08.33l-.12.46-.08.26c-.06.18-.11.35-.18.52a1.72,1.72,0,0,1-.07.21c-.09.24-.18.47-.29.71l0,.08c-.1.21-.19.41-.3.62l-.09.19c-.1.2-.21.39-.31.58l-.07.11c-.13.23-.26.45-.4.66s-.09.13-.13.19l-.32.46-.18.24c-.09.13-.19.25-.29.37s-.16.21-.25.31l-.24.28-.43.45-.27.27-.22.2-.36.32-.22.18-.4.31-.2.14c-.2.14-.4.27-.61.39s-.39.21-.59.3l-.15.07-.13.05a4.11,4.11,0,0,0,1.84,3.24h0a2.17,2.17,0,0,0,.41.19l.09,0h0a2.42,2.42,0,0,0,.36.1l.09,0h0a3.7,3.7,0,0,0,.48.06H76l.19,0h0l.33-.05.26-.06h0l.28-.08.45-.15h0l.32-.12.15-.07a5.45,5.45,0,0,0,.58-.31c.21-.11.41-.25.62-.38a1.33,1.33,0,0,1,.19-.14l.19-.15.21-.16.22-.18.2-.17.17-.15.21-.2.27-.27c.15-.15.29-.3.43-.46l.25-.27h0l.24-.31h0l.29-.37h0l.17-.24h0l.32-.46h0l.13-.19h0c.14-.21.27-.43.4-.66h0l.07-.11h0c.1-.19.21-.38.31-.58h0a1.74,1.74,0,0,1,.1-.19c.1-.21.2-.41.29-.62h0a.36.36,0,0,1,0-.09h0c.1-.23.19-.47.28-.7l.08-.21c.06-.17.12-.35.17-.52h0l.08-.26.12-.46h0c0-.11.06-.22.08-.33h0c0-.12.05-.23.07-.35h0c0-.17.07-.34.09-.51h0l.06-.47a1.64,1.64,0,0,1,0-.22c0-.24,0-.48,0-.71s0-.5,0-.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.01 293.63 61.76 293.97 61.22 293.65 59.54 297.94 65.06 301.15 67.08 295.99 63.01 293.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.17 262.01 85.31 264.41 88.78 260.07 83.26 256.86 80.31 260.54 80.87 260.87 81.17 262.01",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.65,292.91l-2.64.72L67.07,296A9.21,9.21,0,0,1,65.65,292.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.91,264.74a10,10,0,0,1,2.28-.36h.6l.37,0h.15L81.18,262Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.77,284.51h0l.24-1h0c0-.16.09-.32.13-.48h0c.25-.88.55-1.75.89-2.62l-5.52-3.21a2.44,2.44,0,0,1-.1.24c0,.13-.09.27-.14.4s-.17.47-.25.7l-.06.15a3.37,3.37,0,0,1-.1.34c-.08.27-.17.53-.24.79,0,.07,0,.14-.07.22l-.06.26c-.09.32-.16.64-.24,1l-.07.28c0,.12,0,.25-.07.37l5.52,3.21C65.67,284.94,65.73,284.72,65.77,284.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.78,272.22c.46-.59,1-1.14,1.44-1.68l.16-.17h0l.55-.56.23-.24h0c.33-.32.67-.64,1-.94l-5.52-3.21c-.34.3-.68.62-1,.95l-.09.08c-.16.15-.31.31-.46.47l-.24.24c-.26.28-.51.56-.76.85l0,0c-.27.32-.55.64-.81,1h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.63 285.16 60.11 281.95 56.23 285.37 61.75 288.58 65.63 285.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.75 288.58 56.23 285.37 56.24 290.76 61.22 293.65 61.76 293.97 61.75 288.58",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.19 263.57 70.66 260.37 69.65 265.42 75.17 268.63 76.19 263.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.87 260.87 80.31 260.54 75.35 257.66 70.66 260.37 76.19 263.57 80.87 260.87",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.99 277.62 59.47 274.41 61.51 277.24 67.03 280.45 64.99 277.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.78 272.22 66.26 269.01 66.26 269.01 62.77 268.69 68.3 271.9 71.78 272.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.3 271.9 62.77 268.69 59.47 274.41 64.99 277.62 68.3 271.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.54,278l3.88-3.42,0-5.39-3.88,1.07a9.38,9.38,0,0,0-1.43-3.09l.34-.87,1.68-4.3-3.33-1.89-3.47,4.34h-.15l-.37,0h-.6a10,10,0,0,0-2.28.36L81.18,262l-.31-1.14-4.68,2.7-1,5.06c-.34.3-.68.62-1,.94l-.23.24-.55.56-.16.17c-.49.54-1,1.09-1.44,1.68l-3.48-.32L65,277.62l2,2.83c-.34.87-.64,1.74-.89,2.62,0,.16-.09.32-.13.48l-.24,1c0,.21-.1.43-.14.65l-3.88,3.42V294l1.25-.34,2.64-.72A9.21,9.21,0,0,0,67.07,296l-2,5.16,3.33,1.9,3-3.68.51-.65a9.32,9.32,0,0,0,3.41-.34l1,3.87L81,299.54l1-5.05a27.49,27.49,0,0,0,3.39-3.58l3.49.31,3.3-5.72-2-2.82A29.11,29.11,0,0,0,91.54,278Zm-6.58.82-.06.47c0,.17-.06.34-.09.51s0,.23-.07.35,0,.22-.08.33l-.12.46-.08.26c0,.17-.11.35-.17.52l-.08.21c-.09.23-.18.47-.28.7a.36.36,0,0,0,0,.09c-.09.21-.19.41-.29.62a1.74,1.74,0,0,0-.1.19c-.1.2-.21.39-.31.58l-.07.11c-.13.23-.26.45-.4.66l-.13.19-.32.46-.17.24-.29.37c-.09.1-.17.21-.25.31l-.25.27c-.14.16-.28.31-.43.46l-.27.27-.21.2-.17.15q-.32.27-.63.51l-.19.15a1.33,1.33,0,0,0-.19.14c-.21.13-.41.27-.62.38a7.32,7.32,0,0,1-.73.38l-.32.12a4,4,0,0,1-.45.16l-.28.08-.27.06-.33.05-.2,0h-.5a3.7,3.7,0,0,1-.48-.06l-.1,0a2.42,2.42,0,0,1-.36-.1l-.11,0a2.17,2.17,0,0,1-.41-.19h0a4.11,4.11,0,0,1-1.84-3.24,8.37,8.37,0,0,1,0-.89,14.1,14.1,0,0,1,6.4-11.09,7.78,7.78,0,0,1,.87-.43,4,4,0,0,1,3.91.13l.19.13.2.19.17.17a2,2,0,0,1,.18.23,1.33,1.33,0,0,1,.14.19c.06.09.11.18.16.27l.12.22.12.32a1.57,1.57,0,0,1,.09.23c0,.12.07.24.1.37l.06.24c0,.15,0,.3.07.45l0,.23c0,.23,0,.48,0,.73S85,278.47,85,278.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.85,298.72l-.51.65,5,2.88-1-3.87A9.32,9.32,0,0,1,71.85,298.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.52,270.22l3.88-1.07-5-2.89-.34.87A9.38,9.38,0,0,1,91.52,270.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.94,276.89c0-.15,0-.3-.07-.45l-.06-.24c0-.13-.06-.25-.1-.37a1.57,1.57,0,0,0-.09-.23l-.12-.32-.12-.22c0-.09-.1-.18-.16-.27a1.33,1.33,0,0,0-.14-.19,2,2,0,0,0-.18-.23l-.17-.17-.2-.19-.19-.13a4,4,0,0,0-3.91-.13,8.53,8.53,0,0,1,0,.89c0,.23,0,.47,0,.71l0,.23c0,.15,0,.3-.05.46l-.09.51c0,.12,0,.23-.07.35s0,.22-.08.33l-.12.46-.08.26c-.06.18-.11.35-.18.52a1.72,1.72,0,0,1-.07.21c-.09.24-.18.47-.29.71l0,.08c-.1.21-.19.41-.3.62l-.09.19c-.1.2-.21.39-.31.58l-.07.11c-.13.23-.26.45-.4.66s-.09.13-.13.19l-.32.46-.18.24c-.09.13-.19.25-.29.37s-.16.21-.25.31l-.24.28-.43.45-.27.27-.22.2-.36.32-.22.18-.4.31-.2.14c-.2.14-.4.27-.61.39s-.39.21-.59.3l-.15.07-.13.05a4.11,4.11,0,0,0,1.84,3.24h0a2.17,2.17,0,0,0,.41.19l.09,0h0a2.42,2.42,0,0,0,.36.1l.09,0h0a3.7,3.7,0,0,0,.48.06H76l.19,0h0l.33-.05.26-.06h0l.28-.08.45-.15h0l.32-.12.15-.07a5.45,5.45,0,0,0,.58-.31c.21-.11.41-.25.62-.38a1.33,1.33,0,0,1,.19-.14l.19-.15.21-.16.22-.18.2-.17.17-.15.21-.2.27-.27c.15-.15.29-.3.43-.46l.25-.27h0l.24-.31h0l.29-.37h0l.17-.24h0l.32-.46h0l.13-.19h0c.14-.21.27-.43.4-.66h0l.07-.11h0c.1-.19.21-.38.31-.58h0a1.74,1.74,0,0,1,.1-.19c.1-.21.2-.41.29-.62h0a.36.36,0,0,1,0-.09h0c.1-.23.19-.47.28-.7l.08-.21c.06-.17.12-.35.17-.52h0l.08-.26.12-.46h0c0-.11.06-.22.08-.33h0c0-.12.05-.23.07-.35h0c0-.17.07-.34.09-.51h0l.06-.47a1.64,1.64,0,0,1,0-.22c0-.24,0-.48,0-.71s0-.5,0-.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.01 293.63 61.76 293.97 61.22 293.65 59.54 297.94 65.06 301.15 67.08 295.99 63.01 293.63",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.65,292.91l-2.64.72L67.07,296A9.21,9.21,0,0,1,65.65,292.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.91,264.74a10,10,0,0,1,2.28-.36h.6l.37,0h.15L81.18,262Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.77,284.51h0l.24-1h0c0-.16.09-.32.13-.48h0c.25-.88.55-1.75.89-2.62l-5.52-3.21a2.44,2.44,0,0,1-.1.24c0,.13-.09.27-.14.4s-.17.47-.25.7l-.06.15a3.37,3.37,0,0,1-.1.34c-.08.27-.17.53-.24.79,0,.07,0,.14-.07.22l-.06.26c-.09.32-.16.64-.24,1l-.07.28c0,.12,0,.25-.07.37l5.52,3.21C65.67,284.94,65.73,284.72,65.77,284.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.75 288.58 56.23 285.37 56.24 290.76 61.22 293.65 61.76 293.97 61.75 288.58",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.19 263.57 70.66 260.37 69.65 265.42 75.17 268.63 76.19 263.57",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.99 277.62 59.47 274.41 61.51 277.24 67.03 280.45 64.99 277.62",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.78 272.22 66.26 269.01 66.26 269.01 62.77 268.69 68.3 271.9 71.78 272.22",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.17 262.01 85.31 264.41 88.78 260.07 83.26 256.86 80.31 260.54 80.87 260.87 81.17 262.01",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.78,272.22c.46-.59,1-1.14,1.44-1.68l.16-.17h0l.55-.56.23-.24h0c.33-.32.67-.64,1-.94l-5.52-3.21c-.34.3-.68.62-1,.95l-.09.08c-.16.15-.31.31-.46.47l-.24.24c-.26.28-.51.56-.76.85l0,0c-.27.32-.55.64-.81,1h0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.63 285.16 60.11 281.95 56.23 285.37 61.75 288.58 65.63 285.16",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.87 260.87 80.31 260.54 75.35 257.66 70.66 260.37 76.19 263.57 80.87 260.87",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.3 271.9 62.77 268.69 59.47 274.41 64.99 277.62 68.3 271.9",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.4,96.35l-52.3,30.26a6.86,6.86,0,0,0-3.43,5.92v26.6A6.75,6.75,0,0,0,358,164.69l9.54-5.6-4.08,10.64a.65.65,0,0,0,.09.08h0l.06,0,0,0c1,.66,2.76,1.6,3.16,1.81v0a.37.37,0,0,0,.46-.23L381.72,151h0l28.56-16.5a6.83,6.83,0,0,0,3.44-5.93V101.9C413.72,97,406.47,94.59,403.4,96.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.52 159.09 371.56 156.72 366.76 171.66 363.44 169.73 367.52 159.09",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.18,130.76h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.35,133.05a6.87,6.87,0,0,1,1.82-2.29h0a6.09,6.09,0,0,1,.83-.57l52.3-30.26a2.27,2.27,0,0,1,3.41,2c0-4.93-7.25-7.31-10.32-5.55l-52.3,30.26a6.93,6.93,0,0,0-2.55,2.58Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.58,162.71v-26.6a5.51,5.51,0,0,1,.05-.81,7.06,7.06,0,0,1,.72-2.25l-6.8-3.86a6.88,6.88,0,0,0-.88,3.34v26.6A6.75,6.75,0,0,0,358,164.69,2.27,2.27,0,0,1,354.58,162.71Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.52,144.56a.77.77,0,0,1,.1.4,1.91,1.91,0,0,1-.88,1.56c-.45.26-.76.14-.93-.23l-.88-1.81-5.23,3-.9,2.92a2,2,0,0,1-.88,1.19c-.5.29-.88.06-.88-.5a1.93,1.93,0,0,1,.13-.58l4-12.54a2.7,2.7,0,0,1,1.14-1.55l.09-.05c.55-.31.9-.19,1.13.24Zm-7.11.61L367.2,143l-1.91-3.92-1.88,6.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.25,129.49a4.83,4.83,0,0,1,3.69-.87c.18,0,.38.24.38.67a2.06,2.06,0,0,1-.93,1.61.74.74,0,0,1-.59.09,3.25,3.25,0,0,0-2.61.54,8,8,0,0,0-3.49,6.38v0c0,2.55,1.48,3.57,3.69,2.3a8.61,8.61,0,0,0,2.59-2.44V135.5l-2.12,1.22c-.46.27-.86.09-.86-.44a1.88,1.88,0,0,1,.85-1.45l3-1.73c.54-.31,1-.07,1,.55V137a2.69,2.69,0,0,1-.65,1.76,13,13,0,0,1-3.83,3.55c-3.37,2-5.59.47-5.6-3.14A12,12,0,0,1,377.25,129.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.31,125c.52-.3.93-.06.93.53l0,10.4a2,2,0,0,1-.93,1.61c-.54.32-1,.08-1-.52l0-10.4A2,2,0,0,1,385.31,125Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.07,122.22c.53-.31.95-.07.95.52l0,9.41,4.87-2.82c.47-.27.87-.06.87.5a1.9,1.9,0,0,1-.86,1.48l-5.82,3.36c-.53.3-.95.07-.95-.56l0-10.27A2,2,0,0,1,390.07,122.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.86,113.18a.52.52,0,0,1,.85.49,1.86,1.86,0,0,1-.84,1.46l-5.32,3.07v3.21l4.62-2.67c.47-.27.85,0,.85.51a1.85,1.85,0,0,1-.84,1.44l-4.63,2.67v3.33l5.4-3.12c.46-.27.85,0,.85.48a1.86,1.86,0,0,1-.84,1.46l-6.34,3.65c-.54.32-1,.08-1-.54l0-10.18a2,2,0,0,1,1-1.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphic--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.57,196.38l-13.06-7.52-47.72,27.86c2.56-5.41,4.92-10.89,7-16.41.38-1,.74-2,1.11-3,7.37-20.23,11.49-40.88,11.35-60.16-.16-20.39-5.08-36.74-13.51-48.37-.35-.48-.71-1-1.07-1.43a48.93,48.93,0,0,0-13.1-11.8h0l0,0c-.52-.32-1.05-.61-1.58-.91L270.13,68.4v0c-17.87-11.28-43-10.15-70.81,6.06l-1.45.86C162.62,96.53,132,136.86,115.71,179.51c-.41,1.08-.81,2.17-1.21,3.26C107.13,203,103,223.65,103.16,242.93c.16,20.43,5.08,36.79,13.54,48.43l1,1.38a47.89,47.89,0,0,0,18.11,14.44L77,341.57l.22,28.83,13.07,7.52L214.11,305.6,351.8,225.21l11.09-18.87ZM261.11,107c.36.45.7.91,1,1.38,6.27,8.62,9.92,20.76,10,35.91.11,14.27-2.93,29.55-8.37,44.52L263,191c-11.94,31.38-34.31,61.1-60.15,77l-2,1.2c-16.7,9.75-32.13,12.13-44.44,8.23a37.36,37.36,0,0,1-4-4.25c-.37-.47-.74-.94-1.09-1.42-6.29-8.64-10-20.8-10.07-36-.11-14.44,3-29.9,8.56-45,.24-.68.49-1.35.75-2,11.87-31,33.93-60.44,59.46-76.4.86-.53,1.72-1,2.59-1.56,16.69-9.74,32.11-12.14,44.41-8.25A37,37,0,0,1,261.11,107Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.11,107c.36.45.7.91,1,1.38,6.27,8.62,9.92,20.76,10,35.91.11,14.27-2.93,29.55-8.37,44.52l13.06,7.51,5.09,3.44c1-2.3,1.9-4.6,2.78-6.92.38-1,.75-2,1.12-3,7.37-20.23,11.49-40.88,11.34-60.17a111.39,111.39,0,0,0-1.54-18.09l-21.5,2.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.11,107c.36.45.7.91,1,1.38,6.27,8.62,9.92,20.76,10,35.91.11,14.27-2.93,29.55-8.37,44.52l13.06,7.51,5.09,3.44c1-2.3,1.9-4.6,2.78-6.92.38-1,.75-2,1.12-3,7.37-20.23,11.49-40.88,11.34-60.17a111.39,111.39,0,0,0-1.54-18.09l-21.5,2.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.51,188.86l-72.72,42.46A235.45,235.45,0,0,0,282,199.71l-5.09-3.44-13.06-7.51L263,191c-11.94,31.38-34.31,61.1-60.15,77l13.07,7.51,11.42,7.18,111.41-65.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.51,188.86l-72.72,42.46A235.45,235.45,0,0,0,282,199.71l-5.09-3.44-13.06-7.51L263,191c-11.94,31.38-34.31,61.1-60.15,77l13.07,7.51,11.42,7.18,111.41-65.05Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.71,81.26c-.36-.48-.71-1-1.08-1.43-1-1.24-2-2.41-3-3.54l3-.74L270.13,68.4v0c-17.87-11.28-43-10.15-70.81,6.06l-1.45.86,13.06,7.52,5.48,12.92c18.73-5.73,34.7-1.4,44.7,11.17l13.06,7.52,21.5-2.93C293.6,99.39,289.48,89.22,283.71,81.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.75,189.07c.62-1.93,1.29-3.86,2-5.78.25-.67.5-1.35.76-2,11.86-31,33.93-60.44,59.46-76.4.86-.53,1.72-1.05,2.59-1.56a79.9,79.9,0,0,1,16.86-7.53l-5.48-12.92-13.06-7.52C162.62,96.53,132,136.86,115.71,179.51c-.41,1.08-.81,2.17-1.21,3.26l13.06,7.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.75,189.07c.62-1.93,1.29-3.86,2-5.78.25-.67.5-1.35.76-2,11.86-31,33.93-60.44,59.46-76.4.86-.53,1.72-1.05,2.59-1.56a79.9,79.9,0,0,1,16.86-7.53l-5.48-12.92-13.06-7.52C162.62,96.53,132,136.86,115.71,179.51c-.41,1.08-.81,2.17-1.21,3.26l13.06,7.51Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.15,294.34l4.64-18.66a35.57,35.57,0,0,1-12.45-10c-.36-.47-.73-.94-1.08-1.42-6.29-8.63-10-20.79-10.08-36-.09-12.6,2.27-26,6.57-39.25l-7.19,1.21-13.06-7.51C107.13,203,103,223.65,103.16,242.93c.16,20.43,5.08,36.79,13.54,48.43l1,1.38,13.06,7.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.15,294.34l4.64-18.66a35.57,35.57,0,0,1-12.45-10c-.36-.47-.73-.94-1.08-1.42-6.29-8.63-10-20.79-10.08-36-.09-12.6,2.27-26,6.57-39.25l-7.19,1.21-13.06-7.51C107.13,203,103,223.65,103.16,242.93c.16,20.43,5.08,36.79,13.54,48.43l1,1.38,13.06,7.51Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.85 307.18 76.96 341.57 77.18 370.4 158.53 322.91 148.92 314.7 135.85 307.18",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.32,282.74l-11.42-7.18-13.07-7.51-2,1.2c-18.84,11-36.07,12.63-49,6.43l-4.64,18.66-16.34,5.91-13.06-7.51a47.89,47.89,0,0,0,18.11,14.44l13.06,7.52,9.61,8.21,42.52-24.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "135.85 307.18 76.96 341.57 77.18 370.4 158.53 322.91 148.92 314.7 135.85 307.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.32,282.74l-11.42-7.18-13.07-7.51-2,1.2c-18.84,11-36.07,12.63-49,6.43l-4.64,18.66-16.34,5.91-13.06-7.51a47.89,47.89,0,0,0,18.11,14.44l13.06,7.52,9.61,8.21,42.52-24.83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "76.96 341.57 90.02 349.08 148.92 314.7 135.85 307.18 76.96 341.57",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.96 341.57 90.02 349.08 148.92 314.7 135.85 307.18 76.96 341.57",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.18 370.4 90.25 377.92 90.02 349.08 76.96 341.57 77.18 370.4",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.18 370.4 90.25 377.92 90.02 349.08 76.96 341.57 77.18 370.4",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.57 196.38 338.51 188.86 265.79 231.32 278.86 238.83 351.57 196.38",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.57 196.38 338.51 188.86 265.79 231.32 278.86 238.83 351.57 196.38",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.41,273.23c12.9,16.12,35.68,18.6,61.48,3.54l-65,37.93a48,48,0,0,1-18.11-14.45l16.34-5.91Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.41,273.23c12.9,16.12,35.68,18.6,61.48,3.54l-65,37.93a48,48,0,0,1-18.11-14.45l16.34-5.91Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.9,275.56l11,8.11-10.71,20.7c-.68.42-1.36.83-2,1.23L90.25,377.92,90,349.08l58.9-34.38,65-37.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.9,275.56l11,8.11-10.71,20.7c-.68.42-1.36.83-2,1.23L90.25,377.92,90,349.08l58.9-34.38,65-37.93Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M127.56,190.28l5.31,14.19,16.94-13.66c-5.56,15.13-8.67,30.59-8.56,45,.11,15.17,3.78,27.33,10.07,36,.35.48.72.95,1.09,1.42l-5.26,21.11-16.34,5.91c-.35-.45-.7-.92-1-1.38-8.46-11.63-13.39-28-13.55-48.42C116.07,231.16,120.19,210.51,127.56,190.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.56,190.28l5.31,14.19,16.94-13.66c-5.56,15.13-8.67,30.59-8.56,45,.11,15.17,3.78,27.33,10.07,36,.35.48.72.95,1.09,1.42l-5.26,21.11-16.34,5.91c-.35-.45-.7-.92-1-1.38-8.46-11.63-13.39-28-13.55-48.42C116.07,231.16,120.19,210.51,127.56,190.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M351.57,196.38l11.32,10L351.8,225.21,214.11,305.6c.69-.4,1.37-.81,2-1.23,24.16-14.69,46.09-38.35,62.7-65.54Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.57,196.38l11.32,10L351.8,225.21,214.11,305.6c.69-.4,1.37-.81,2-1.23,24.16-14.69,46.09-38.35,62.7-65.54Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.52,182.85l5.41,14.46c-.37,1-.73,2-1.11,3a234.41,234.41,0,0,1-19,38.52c-16.61,27.19-38.54,50.85-62.7,65.54l10.71-20.7-11-8.11c25.84-15.91,48.2-45.64,60.14-77l.84-2.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.52,182.85l5.41,14.46c-.37,1-.73,2-1.11,3a234.41,234.41,0,0,1-19,38.52c-16.61,27.19-38.54,50.85-62.7,65.54l10.71-20.7-11-8.11c25.84-15.91,48.2-45.64,60.14-77l.84-2.28Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.47,93.21l16.23-5.86c.36.46.72,1,1.07,1.43,8.43,11.63,13.35,28,13.51,48.37.14,19.28-4,39.94-11.35,60.16l-5.41-14.46-16.64,13.42c5.44-15,8.48-30.24,8.37-44.51-.12-15.15-3.76-27.29-10-35.92-.33-.46-.68-.92-1-1.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.47,93.21l16.23-5.86c.36.46.72,1,1.07,1.43,8.43,11.63,13.35,28,13.51,48.37.14,19.28-4,39.94-11.35,60.16l-5.41-14.46-16.64,13.42c5.44-15,8.48-30.24,8.37-44.51-.12-15.15-3.76-27.29-10-35.92-.33-.46-.68-.92-1-1.37Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.39,82c35.07-20.47,66-16.9,83.31,5.36l-16.23,5.86-5.3,21.26c-12.88-16.21-35.71-18.73-61.56-3.64-.87.51-1.73,1-2.59,1.56l-10.38-7.67,11.29-21.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.39,82c35.07-20.47,66-16.9,83.31,5.36l-16.23,5.86-5.3,21.26c-12.88-16.21-35.71-18.73-61.56-3.64-.87.51-1.73,1-2.59,1.56l-10.38-7.67,11.29-21.86Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M210.93,82.86l-11.29,21.86L210,112.39c-25.53,16-47.59,45.35-59.46,76.4-.26.67-.51,1.34-.75,2l-16.94,13.66-5.31-14.19c.4-1.09.81-2.17,1.22-3.25C145.09,144.38,175.68,104,210.93,82.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.16,240.68a.3.3,0,0,1,.36,0c.14.14.1.46-.09.73a.86.86,0,0,1-.2.22,4.92,4.92,0,0,0-1,1c-.32.46-.39.83-.23,1s.19.06.32,0a6,6,0,0,0,.89-.78,6,6,0,0,1,1-.85c.34-.19.66-.25.9,0h0c.57.55.27,1.68-.49,2.77a6,6,0,0,1-1.71,1.67l-.05,0a.28.28,0,0,1-.33,0c-.14-.14-.11-.45.08-.73a1.23,1.23,0,0,1,.22-.23,4.48,4.48,0,0,0,1.31-1.25c.36-.51.45-.92.27-1.09h0c-.08-.07-.19,0-.32,0a6,6,0,0,0-.88.78,4.94,4.94,0,0,1-1,.87.71.71,0,0,1-.92,0h0c-.51-.5-.26-1.61.47-2.66a6.41,6.41,0,0,1,1.36-1.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.64,247.7a.48.48,0,0,1,.06.36,5.36,5.36,0,0,1-1,2.21,4.66,4.66,0,0,1-1.33,1.25,1.43,1.43,0,0,1-1.92-.14c-.74-.84-.57-2.55.52-4a3.92,3.92,0,0,1,1.18-1.12,1.41,1.41,0,0,1,1.86.13c.16.18.09.57-.14.87l-2.36,3.18a.89.89,0,0,0,1,0,2.41,2.41,0,0,0,.74-.7,3.85,3.85,0,0,0,.67-1.45.9.9,0,0,1,.17-.36.79.79,0,0,1,.23-.22A.27.27,0,0,1,262.64,247.7Zm-3.23.23a2,2,0,0,0-.31,2.08L261,247.4a.85.85,0,0,0-1,0,2,2,0,0,0-.61.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.25,251.91c.84,1.21.36,3.55-1.29,5.57l-1.48,1.83a1,1,0,0,1-.27.24.32.32,0,0,1-.46-.05L251.29,256a.88.88,0,0,1,.2-1l1.49-1.83a6.41,6.41,0,0,1,1.71-1.54c1.05-.61,2-.53,2.55.26Zm-1.76,4.88c1.09-1.34,1.39-2.83.8-3.68v0a1.21,1.21,0,0,0-1.73-.22,4.13,4.13,0,0,0-1.1,1l-1,1.27,2,2.92,1-1.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.38,239.84c.19.15.15.55-.08.89a1,1,0,0,1-.33.33.35.35,0,0,1-.39,0l-2.28-1.9c-.19-.16-.16-.54.06-.88a1.15,1.15,0,0,1,.33-.33.36.36,0,0,1,.42,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.11,237c.21.16.14.58-.13,1a1.35,1.35,0,0,1-.4.42.35.35,0,0,1-.39,0l0,0c-.19-.16-.12-.57.14-1a1.37,1.37,0,0,1,.41-.42.32.32,0,0,1,.37,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.55,232.54a1.65,1.65,0,0,1,.72,1.5,5.62,5.62,0,0,1-1,2.52,9.1,9.1,0,0,1-1.57,1.91,1,1,0,0,1-.18.14.29.29,0,0,1-.32,0c-.16-.11-.14-.44,0-.73l.17-.21a6.22,6.22,0,0,0,1.28-1.5c.69-1.12.74-1.95.13-2.38l-.24-.16A3.61,3.61,0,0,1,271,236a4.09,4.09,0,0,1-1.38,1.42,1.41,1.41,0,0,1-1.57.06c-.91-.65-.7-2.22.09-3.49a3.78,3.78,0,0,1,1.32-1.35,2.69,2.69,0,0,1,.38-.19l-.15-.1c-.18-.13-.16-.52,0-.86a1.21,1.21,0,0,1,.35-.36.37.37,0,0,1,.39,0Zm-2,2.67c.54-.86.66-1.84.16-2.19h0a.81.81,0,0,0-.9,0,2.86,2.86,0,0,0-.93,1c-.53.86-.62,1.77-.12,2.13h0a.84.84,0,0,0,.91,0,2.66,2.66,0,0,0,.88-.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.77,225.06A1.25,1.25,0,0,1,275,225l1.74,1c.21.12.21.48,0,.84a1.13,1.13,0,0,1-.38.4.4.4,0,0,1-.36,0l-1.51-.83a.76.76,0,0,0-.81,0,1.88,1.88,0,0,0-.66.74c-.42.74-.42,1.42.09,1.7l1.5.81c.21.12.21.49,0,.84a1.09,1.09,0,0,1-.36.4.41.41,0,0,1-.37,0l-2.57-1.41c-.21-.12-.22-.48,0-.84a1,1,0,0,1,.37-.39.36.36,0,0,1,.37,0l.17.08a2.84,2.84,0,0,1,.42-2.05A3.32,3.32,0,0,1,273.77,225.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.61,116.18c.56,1.75-.3,4.13-1.93,5.62a5.18,5.18,0,0,1-.91.7c-1.3.74-2.47.44-2.92-1l-.5-1.6a1.06,1.06,0,0,1,.35-1l4.75-4.39.15-.11c.23-.13.44-.09.51.14Zm-2.27,4.6a3.89,3.89,0,0,0,1.35-3.75l-.35-1.12-3.92,3.63.35,1.11c.3.95,1,1.14,1.9.65a3.91,3.91,0,0,0,.65-.5l0,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.62,134a4.64,4.64,0,0,1-2,3.88l-.06,0c-.26.15-.46.05-.49-.22l-.31-3.08a2.74,2.74,0,0,0-1,2.22,1.05,1.05,0,0,0,.51.89.24.24,0,0,1,.12.22.86.86,0,0,1-.37.74l0,0a.41.41,0,0,1-.29.05,1.5,1.5,0,0,1-.78-1.35,4.85,4.85,0,0,1,2.09-4.16l0,0a2.82,2.82,0,0,1,.29-.18C297.49,132.41,298.49,132.73,298.62,134Zm-1.91,2.66a2.56,2.56,0,0,0,1.06-2.08c-.07-.69-.61-.83-1.32-.45l.26,2.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.73,141.56c1.29-.75,2.36-.21,2.39,1.38a5.13,5.13,0,0,1-2.31,4.15h0l0,0c-1.27.74-2.35.19-2.37-1.39a5.14,5.14,0,0,1,2.31-4.14Zm0,4.35a3.07,3.07,0,0,0,1.44-2.46c0-.93-.66-1.16-1.44-.71l0,0h0a3.08,3.08,0,0,0-1.43,2.44c0,1,.67,1.18,1.44.74l0,0h0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.12,136.92c.27-.15.5,0,.52.26a1.13,1.13,0,0,1-.48.92l-5.33,3.45,0,0c-.28.16-.5,0-.52-.27a1.13,1.13,0,0,1,.49-.91l5.32-3.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.23,148.72c.46.15.81.52.78,1.39a4.71,4.71,0,0,1-2.29,3.6l-.16.09h0c-1.51.78-2.31,0-2.26-1.26a4.2,4.2,0,0,1,.88-2.24l-1.6.83c-.3.15-.51,0-.5-.35a1.15,1.15,0,0,1,.51-.85l0,0,5-2.57c.29-.15.51,0,.5.34a1.17,1.17,0,0,1-.53.87l0,0Zm-.11,1.56c0-.83-.52-1.26-1.39-.81h0l-.1.06a3,3,0,0,0-1.42,2.26c0,.84.49,1.24,1.38.78h0l.11-.06a2.92,2.92,0,0,0,1.41-2.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.76,81.54a.46.46,0,0,1,.24-.08c.25,0,.35.31.22.68l-.34,1h.72c.23,0,.32.26.21.57a1,1,0,0,1-.4.52.49.49,0,0,1-.22.06h-.73l-1,2.87c-.19.52-.08.73.24.73a.66.66,0,0,0,.24,0c.21,0,.3.25.19.57a.9.9,0,0,1-.39.49l0,0a1.91,1.91,0,0,1-.69.15c-.69,0-1-.45-.56-1.74l1.08-3.07h-.15c-.22,0-.32-.26-.2-.58a1,1,0,0,1,.4-.51.36.36,0,0,1,.2-.06h.15l.36-1A1.13,1.13,0,0,1,251.76,81.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.39,83.36a1.91,1.91,0,0,1,.81-.25,1.61,1.61,0,0,1,1.16.41.48.48,0,0,1,.06.49.92.92,0,0,1-.38.51.6.6,0,0,1-.19.06.23.23,0,0,1-.16-.06,1.23,1.23,0,0,0-.85-.35.89.89,0,0,0-.36.11.9.9,0,0,0-.4.5v0c-.13.42.25.58.67.77a1.15,1.15,0,0,1,.74,1.63v0a2.87,2.87,0,0,1-1.23,1.64,1.88,1.88,0,0,1-.89.27,1.55,1.55,0,0,1-1.36-.61.49.49,0,0,1,0-.46.9.9,0,0,1,.38-.5.27.27,0,0,1,.17-.06.25.25,0,0,1,.18.07,1.21,1.21,0,0,0,1,.5.94.94,0,0,0,.42-.12,1,1,0,0,0,.43-.55c.15-.47-.24-.6-.66-.79s-1.1-.53-.75-1.64A2.9,2.9,0,0,1,247.39,83.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.8,83.49c1.35-.18,1.59,1.26,1.21,2.61a1.08,1.08,0,0,1-.45.63.64.64,0,0,1-.18.06l-2.66.35c-.17.93.18,1.39.8,1.31a1.47,1.47,0,0,0,.6-.2,2.72,2.72,0,0,0,.55-.44l.13-.09a.25.25,0,0,1,.15,0c.22,0,.32.18.24.49a1.17,1.17,0,0,1-.25.42,4.11,4.11,0,0,1-.82.65,2.35,2.35,0,0,1-.92.32c-1.23.16-1.83-1-1.33-2.74v0a5.18,5.18,0,0,1,2.13-3A2,2,0,0,1,243.8,83.49Zm.33,2.48c.18-.85,0-1.48-.64-1.39a1.11,1.11,0,0,0-.41.14A3,3,0,0,0,242,86.25l2.17-.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.93,82.85a.52.52,0,0,1,.16-.06l3.8-.75c.26-.05.39.2.31.54a1.1,1.1,0,0,1-.46.65l-.15.06-1.4.27-1.42,5.81a1.19,1.19,0,0,1-.5.7.41.41,0,0,1-.17.07c-.28,0-.43-.2-.34-.57l1.42-5.81-1.39.28c-.27,0-.4-.19-.32-.53A1.16,1.16,0,0,1,237.93,82.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,154.23a.35.35,0,0,1,.11.32,4.89,4.89,0,0,1-.79,2.23,4.64,4.64,0,0,1-1.57,1.65,1.6,1.6,0,0,1-1.74.08h0c-.88-.59-.93-2.18,0-3.75a4.31,4.31,0,0,1,1.42-1.48,1.58,1.58,0,0,1,1.69-.09c.2.13.17.5,0,.82L155,157.42a1,1,0,0,0,.86-.12,2.56,2.56,0,0,0,.88-.93,3.48,3.48,0,0,0,.52-1.47.72.72,0,0,1,.13-.36.87.87,0,0,1,.28-.29A.27.27,0,0,1,158,154.23Zm-3.4.93a1.62,1.62,0,0,0-.06,2l1.71-2.81a1,1,0,0,0-.93.08,2.16,2.16,0,0,0-.72.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,159.24c1.24.64,1.31,2.74,0,5.07l-1.17,2.1a1.07,1.07,0,0,1-.39.42.36.36,0,0,1-.37,0L147.25,165c-.22-.11-.22-.48,0-.85l1.18-2.11a6.92,6.92,0,0,1,2.35-2.61A2.11,2.11,0,0,1,152.78,159.24Zm-.69,4.71c.87-1.56.81-2.89-.05-3.33h0a1.48,1.48,0,0,0-1.41.13,4.31,4.31,0,0,0-1.51,1.69l-.81,1.46,3,1.53.82-1.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.22,137.45c.72.83.45,2.67-.72,4.23a4.8,4.8,0,0,1-1.35,1.27,1.49,1.49,0,0,1-2-.09h0c-.72-.83-.45-2.68.71-4.24a4.79,4.79,0,0,1,1.37-1.26,1.47,1.47,0,0,1,2,.08ZM167,141.07a2,2,0,0,0,.35-2.45v0a1,1,0,0,0-1.23-.08,2.59,2.59,0,0,0-.75.71,2.07,2.07,0,0,0-.34,2.45h0a.91.91,0,0,0,1.21.08,2.44,2.44,0,0,0,.75-.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.82,142a.31.31,0,0,1,.41,0l3.16,3.13c.17.17.12.58-.11.9a1.44,1.44,0,0,1-.31.3.34.34,0,0,1-.42,0l-3.15-3.14c-.17-.16-.13-.55.11-.89A.94.94,0,0,1,160.82,142Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.57,146.52c1,.81.7,2.47-.13,3.73a3.55,3.55,0,0,1-1.15,1.15,2.85,2.85,0,0,1-.56.24l1,.85c.19.16.15.55-.08.9a.94.94,0,0,1-.32.31.36.36,0,0,1-.41,0l-3.13-2.65c-.18-.15-.16-.54.07-.88a1.15,1.15,0,0,1,.33-.33.35.35,0,0,1,.41,0l.17.16a3.71,3.71,0,0,1,.67-2.28,4.1,4.1,0,0,1,1.28-1.25A1.53,1.53,0,0,1,161.57,146.52Zm-.9,3.54c.56-.83.66-1.81.09-2.29h0a.94.94,0,0,0-1.14,0,2.38,2.38,0,0,0-.78.77c-.55.82-.66,1.86-.11,2.32h0a1,1,0,0,0,1.14,0,2.5,2.5,0,0,0,.8-.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.12,130.83c.17-.09.33-.09.42,0a.57.57,0,0,1,.09.22l.56,4.61a3,3,0,0,1-.69,2.54,3.71,3.71,0,0,1-.68.69l-.12.08c-.14.08-.29.11-.39,0a.71.71,0,0,1,.15-.76c.08-.09.13-.13.18-.18a2.77,2.77,0,0,0,.35-.34,1.34,1.34,0,0,0,.32-1l0-.1-3.35-.86a.4.4,0,0,1-.18-.11.85.85,0,0,1,.19-.92,1,1,0,0,1,.25-.23.49.49,0,0,1,.39,0l2.57.82-.53-3.35a1,1,0,0,1,.23-.82A1.1,1.1,0,0,1,171.12,130.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.43,258.56a4.79,4.79,0,0,1-1.86,4.23h0a3.1,3.1,0,0,1-.51.35c-1.08.62-2,.4-2.24-.75a4.52,4.52,0,0,1,1.77-3.95l.11-.08c.24-.14.43-.06.48.18l.56,2.9a2.63,2.63,0,0,0,.87-2.24.94.94,0,0,0-.6-.78.23.23,0,0,1-.14-.2.84.84,0,0,1,.33-.75l.08-.05a.39.39,0,0,1,.26-.06A1.34,1.34,0,0,1,132.43,258.56Zm-2.5,3.51L130,262l-.45-2.37a2.5,2.5,0,0,0-1,2.11c.12.62.64.71,1.3.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.1,265.85a1.07,1.07,0,0,1-.37,1l-4.84,4.27a.49.49,0,0,1-.14.11c-.24.14-.44.08-.51-.17l-.55-2.07a3.47,3.47,0,0,1,.13-2.18,4.1,4.1,0,0,1,1.12-1.58v0a3,3,0,0,1,.55-.4,1.1,1.1,0,0,1,1.55.18l1.1-2.35a1.47,1.47,0,0,1,.34-.51l.13-.09c.23-.14.43-.05.48.16a1,1,0,0,1-.13.73l-1.42,3,.34,1.29,1.56-1.39.14-.09C133.82,265.56,134,265.61,134.1,265.85ZM129,269.7l2-1.73-.4-1.49c-.17-.61-.56-.8-1-.53l-.27.2h0a2,2,0,0,0-.64,2.06l.41,1.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.76,237.49a.92.92,0,0,1,.24-.09l3.46-.47c.32,0,.46.13.45.42v0a1.28,1.28,0,0,1-.45.91l-2.72,2.51,2.68-.45c.29-.05.44.12.43.41v0a1.31,1.31,0,0,1-.48.93l-3.48,3.31a1.39,1.39,0,0,1-.27.21c-.25.14-.47,0-.47-.32a1.22,1.22,0,0,1,.42-.82l2.78-2.53-2.74.47c-.23,0-.4-.08-.4-.39v-.07a1.28,1.28,0,0,1,.43-.84l2.77-2.55-2.74.48c-.23,0-.4-.05-.4-.37A1.08,1.08,0,0,1,126.76,237.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.3,244.18a1.61,1.61,0,0,1,.68,1.46,4.93,4.93,0,0,1-2.24,4.1l-.14.08c-1.25.72-2.29.34-2.35-1.07a4.69,4.69,0,0,1,2.13-3.83l0,0c.27-.16.46,0,.48.25l.14,3.2a2.82,2.82,0,0,0,1.09-2.2,1.12,1.12,0,0,0-.45-1,.3.3,0,0,1-.11-.24.91.91,0,0,1,.4-.73h0A.31.31,0,0,1,130.3,244.18Zm-3.2,4c0,.72.54.91,1.25.57l-.11-2.61a2.55,2.55,0,0,0-1.14,2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.68,249.67c.27-.16.49,0,.51.25a1.12,1.12,0,0,1-.47.92l-3.58,2.44,0,0c-.27.15-.49.06-.52-.24a1.17,1.17,0,0,1,.48-.93l3.58-2.44S130.66,249.67,130.68,249.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.27,254.44a.87.87,0,0,1,.19-.08l3.65-.92c.28-.06.49,0,.53.3v.06a1.31,1.31,0,0,1-.37.95l-3.22,4.13a1.18,1.18,0,0,1-.25.25l0,0c-.24.14-.48.06-.52-.22a1.1,1.1,0,0,1,.31-.82l2.82-3.43-3.16.94c-.2.05-.39,0-.43-.25a1.05,1.05,0,0,1,.43-.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.45,253.15c.29-.16.49,0,.52.33a1.11,1.11,0,0,1-.45,1l0,0,0,0c-.28.16-.48,0-.52-.33a1.12,1.12,0,0,1,.45-1l.05,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.48,324.84c1.4-.81,2.28-.4,2.29,1a4.58,4.58,0,0,1-2.4,3.77l-1.2.69V332a1.13,1.13,0,0,1-.52.9c-.31.18-.54.05-.54-.29l0-5.75a1.15,1.15,0,0,1,.54-.92Zm1.22,1.66v0c0-.81-.52-.94-1.31-.48l-1.23.7v2.5l1.23-.71a2.46,2.46,0,0,0,1.3-2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.3,322.28c.29-.16.52,0,.52.3l0,6.12a1.13,1.13,0,0,1-.52.9c-.29.16-.52,0-.52-.3l0-6.12A1.14,1.14,0,0,1,153.3,322.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.5,321.84c.34.18.5.65.5,1.33v2.57a1.08,1.08,0,0,1-.51.86c-.3.18-.51.06-.51-.21v-.19a3.85,3.85,0,0,1-1.48,1.61c-.84.49-1.61.37-1.61-.68v0a3.33,3.33,0,0,1,1.87-2.76,4.22,4.22,0,0,1,1.22-.49v-.13c0-.74-.39-.9-1.13-.48a4.71,4.71,0,0,0-1,.79l-.16.12c-.24.14-.44,0-.44-.24a1,1,0,0,1,.29-.64,6.51,6.51,0,0,1,1.46-1.15C157.68,321.74,158.19,321.65,158.5,321.84ZM158,325v-.35a2.86,2.86,0,0,0-1,.38,1.88,1.88,0,0,0-1.07,1.5h0c0,.51.39.57.9.28A2.34,2.34,0,0,0,158,325",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.7,318.8c1-.6,1.61-.14,1.62,1.06v2.79a1.07,1.07,0,0,1-.5.88c-.3.18-.53.06-.54-.28v-2.42c0-.81-.35-1.07-1-.72a2.18,2.18,0,0,0-1,1.89v2.4a1.1,1.1,0,0,1-.52.89c-.28.17-.52,0-.52-.29v-4.13a1.12,1.12,0,0,1,.51-.9c.29-.17.53,0,.53.3v.26A3.54,3.54,0,0,1,162.7,318.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.33,239.41c.29-.17.52,0,.52.3l0,5.26,2.73-1.58c.26-.15.48,0,.48.28a1,1,0,0,1-.48.82l-3.25,1.88c-.3.18-.54,0-.54-.3l0-5.75A1.18,1.18,0,0,1,297.33,239.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.33,237.06c.34.18.49.64.49,1.32V241a1.07,1.07,0,0,1-.51.87c-.3.17-.51.06-.51-.21v-.2a3.91,3.91,0,0,1-1.47,1.62c-.85.49-1.61.36-1.61-.68v0a3.31,3.31,0,0,1,1.87-2.76,4,4,0,0,1,1.22-.49V239c0-.74-.4-.92-1.13-.49a4.54,4.54,0,0,0-1,.79l-.16.12c-.24.14-.44,0-.44-.24a1,1,0,0,1,.28-.64,6.51,6.51,0,0,1,1.46-1.15C304.5,237,305,236.86,305.33,237.06Zm-.5,3.11v-.35a2.7,2.7,0,0,0-1,.38,1.86,1.86,0,0,0-1.07,1.49v0c0,.5.39.57.89.28a2.31,2.31,0,0,0,1.2-1.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.57,233.46c.28-.16.52,0,.52.3v4.13a1.13,1.13,0,0,1-.52.89c-.28.17-.52.05-.52-.29v-.26a3.61,3.61,0,0,1-1.42,1.73c-1,.6-1.62.15-1.62-1.07v-2.77a1.14,1.14,0,0,1,.51-.9c.3-.17.53,0,.53.29v2.42c0,.82.35,1.07,1,.71a2.14,2.14,0,0,0,1-1.88v-2.4A1.15,1.15,0,0,1,310.57,233.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.86,230.93c1-.59,1.62-.14,1.62,1.06v2.79a1.12,1.12,0,0,1-.51.89c-.3.17-.53,0-.53-.29V233c0-.81-.35-1.07-1-.71a2.15,2.15,0,0,0-1,1.88v2.4a1.13,1.13,0,0,1-.52.9c-.28.16-.52,0-.52-.3V233a1.15,1.15,0,0,1,.52-.9c.29-.16.52,0,.52.3v.26A3.66,3.66,0,0,1,314.86,230.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.85,228.05a1.71,1.71,0,0,1,1.59-.26c.07,0,.16.11.16.31a1,1,0,0,1-.48.83.49.49,0,0,1-.31.06,1,1,0,0,0-1,.11,3,3,0,0,0-1.31,2.42v0c0,.93.56,1.35,1.36.89a3,3,0,0,0,1-1.05.89.89,0,0,1,.29-.29c.25-.15.45,0,.45.26a.81.81,0,0,1-.15.46,4.45,4.45,0,0,1-1.65,1.69c-1.35.78-2.35.14-2.35-1.33v0A5.12,5.12,0,0,1,319.85,228.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.15,224.2c.29-.16.53,0,.53.3v2.25A3.61,3.61,0,0,1,325.1,225c1-.59,1.62-.14,1.62,1.06v2.79a1.12,1.12,0,0,1-.51.89c-.3.17-.53,0-.53-.29v-2.42c0-.82-.36-1.07-1-.71a2.15,2.15,0,0,0-1,1.88v2.4a1.12,1.12,0,0,1-.52.89c-.28.17-.51,0-.52-.29V225.1A1.14,1.14,0,0,1,323.15,224.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.24,209.36l-.5.46Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.45,206.19c.44-.22.9-.44,1.36-.71s.95-.58,1.41-.9l.45-.33c.32-.22.63-.45.94-.7l.5-.42c.29-.24.57-.48.84-.73l.5-.47.63-.63c.34-.34.67-.69,1-1.06l.57-.64c.2-.23.39-.47.58-.71s.45-.56.67-.85l.42-.57c.25-.35.5-.7.74-1.06.09-.15.19-.29.28-.43.33-.5.64-1,.94-1.53l.15-.27c.25-.43.49-.88.72-1.33l.23-.45c.23-.47.46-1,.68-1.44a1.42,1.42,0,0,1,.08-.18c.24-.55.46-1.09.66-1.64l.18-.49c.14-.4.27-.79.4-1.19l.18-.62c.11-.35.2-.7.29-1.06s.13-.51.18-.76.11-.54.16-.81.15-.8.21-1.19.09-.71.13-1.06c0-.18,0-.36,0-.53,0-.55.07-1.1.06-1.64a17,17,0,0,0-.13-2.06,18.38,18.38,0,0,0-2,1c-8.21,4.74-14.87,16.26-14.84,25.69a17,17,0,0,0,.14,2.07l.29-.12Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.47,178.77c.13.13.27.24.39.38C230.74,179,230.6,178.9,230.47,178.77Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.06,214Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.46,211.69,220,212Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.56,178c.15.1.31.2.45.31C229.87,178.22,229.71,178.12,229.56,178Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,183.39c0,.19.11.37.15.57C233.07,183.76,233,183.58,233,183.39Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.26,185c0,.18.06.34.08.52C233.32,185.34,233.29,185.18,233.26,185Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,180.76l.28.5Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.53,182c.07.18.15.35.21.54C232.68,182.35,232.6,182.18,232.53,182Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.27,179.68c.11.15.23.29.34.45C231.5,180,231.38,179.83,231.27,179.68Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.92,156l.86,0-.86,0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.14,170.29l.35-.39h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.86,207.68c-.33.36-.65.71-1,1C224.21,208.39,224.53,208,224.86,207.68Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.54,156h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.75,196.08c-.06.16-.11.33-.17.49C231.64,196.41,231.7,196.24,231.75,196.08Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.43,200.41h0c.1-.37.2-.74.31-1.11h0C189.63,199.67,189.53,200,189.43,200.41Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.78,168.59l.53-.54h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.55,204.15c.1-.51.22-1,.34-1.52h0C188.77,203.14,188.65,203.64,188.55,204.15Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.44,214.93h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.83,203.84h0l.29-.43h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.06,201.88h0l.15-.26h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,214.41l.27.1,0,0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.93,200.28c.07-.14.15-.29.22-.44-.07.15-.15.3-.22.44Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.62,193.21h0c.07-.25.13-.5.19-.76h0C232.75,192.71,232.69,193,232.62,193.21Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.3,189.38c.07-.73.12-1.45.12-2.16,0,.54,0,1.09-.07,1.64C233.34,189,233.32,189.21,233.3,189.38Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.83,198.4h0l.09-.2h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,191.64h0c.08-.4.15-.79.2-1.19h0C233.12,190.85,233.05,191.24,233,191.64Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.15,194.89c.07-.21.13-.41.19-.61-.06.2-.12.4-.19.61Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.68,205.46h0l.41-.57h0C227,205.09,226.82,205.28,226.68,205.46Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.84,214.74a6,6,0,0,0,.61-.13h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.61,214.91l.46,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.1,214.74l.25.06h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.1,214.43c.35-.1.7-.23,1.06-.36h0A10.86,10.86,0,0,1,215.1,214.43Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.39,211l-.49.37c.49-.37,1-.77,1.46-1.19l-.46.4Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.89,213.77a18.1,18.1,0,0,0,1.7-.86c-.46.27-.91.49-1.36.71Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.43,207h0l.58-.7h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,235.54l-1.21,1.5,11.49,6.68-2.41-9A21.47,21.47,0,0,1,203,235.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.49,169.54l9-2.47L246,160.38l-.79,2A21.29,21.29,0,0,1,248.49,169.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.26,185c0-.35-.08-.71-.15-1s-.1-.38-.15-.57-.13-.58-.22-.85-.14-.36-.21-.54-.18-.51-.29-.74l-.28-.5c-.11-.21-.22-.43-.35-.63s-.23-.3-.34-.45-.26-.36-.41-.53-.26-.25-.39-.38-.3-.3-.46-.44-.3-.21-.45-.31c-2.31-1.61-5.48-1.8-9.06-.29a17,17,0,0,1,.13,2.06c0,.54,0,1.09-.06,1.64,0,.17,0,.35,0,.53,0,.35-.08.7-.13,1.06s-.13.79-.21,1.19-.1.54-.16.81-.12.51-.18.76-.18.71-.29,1.06l-.18.62c-.13.4-.26.79-.4,1.19l-.18.49c-.2.55-.42,1.09-.66,1.64a1.42,1.42,0,0,0-.08.18c-.22.49-.45,1-.68,1.44l-.23.45c-.23.45-.47.9-.72,1.33l-.15.27c-.3.52-.61,1-.94,1.53-.09.14-.19.28-.28.43-.24.36-.49.71-.74,1.06l-.42.57c-.22.29-.44.57-.67.85s-.38.48-.58.71l-.57.64c-.32.37-.65.72-1,1.06l-.63.63-.5.47c-.27.25-.55.49-.84.73l-.5.42c-.31.25-.62.48-.94.7l-.45.33c-.46.32-.94.62-1.41.9s-.92.49-1.36.71l-.36.16-.29.12c.43,3.61,2,6.19,4.26,7.5h0a6.92,6.92,0,0,0,1,.44l.22.08,0,0a6.89,6.89,0,0,0,.81.23l.22,0h0a9.55,9.55,0,0,0,1.09.13h.26c.3,0,.6,0,.91,0l.43,0h0l.77-.12.6-.12h0c.22-.05.44-.11.65-.18a10.86,10.86,0,0,0,1.05-.36h0l.73-.3.34-.15c.45-.22.9-.44,1.36-.71s.95-.58,1.42-.9l.45-.32.44-.34.49-.37.51-.42.46-.4c.13-.11.26-.22.38-.34l.5-.46.63-.63c.34-.34.66-.69,1-1l.57-.65h0l.58-.7h0l.67-.86h0c.14-.18.28-.37.41-.56h0c.26-.35.5-.7.74-1.06h0l.29-.43h0c.32-.5.64-1,.94-1.53h0l.15-.26h0c.25-.44.49-.89.72-1.34h0c.07-.14.15-.29.22-.44.24-.48.47-1,.68-1.44h0l.09-.2h0c.24-.54.45-1.08.66-1.63.06-.16.11-.33.17-.49.15-.4.28-.79.4-1.19h0c.07-.21.13-.41.19-.61.1-.36.19-.71.28-1.07h0c.07-.25.13-.5.19-.76h0c.06-.27.11-.54.16-.81h0c.08-.4.15-.79.2-1.19h0c.05-.36.1-.71.13-1.07,0-.17,0-.35,0-.52.05-.55.07-1.1.07-1.64s0-1.15-.08-1.7C233.32,185.34,233.28,185.18,233.26,185Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.48 223.75 179.59 224.54 178.33 223.8 174.44 233.75 187.23 241.18 191.9 229.22 182.48 223.75",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.55 150.53 234.12 156.09 242.16 146.04 229.37 138.61 222.54 147.14 223.84 147.9 224.55 150.53",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.6,222.08l-6.12,1.67,9.42,5.47A20.74,20.74,0,0,1,188.6,222.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.25,156.86a23.77,23.77,0,0,1,5.29-.83h.28c.37,0,.74,0,1.1,0h0l.86,0,.34,0-9.57-5.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.89,202.63h0q.24-1.11.54-2.22h0c.1-.37.2-.74.31-1.11h0q.87-3,2-6.07L179,185.8c-.08.19-.15.37-.22.56s-.22.62-.33.93c-.2.54-.4,1.08-.59,1.62l-.12.36c-.09.26-.16.52-.25.78-.19.61-.38,1.22-.55,1.82,0,.17-.11.34-.15.5s-.1.4-.15.6c-.2.75-.38,1.49-.55,2.23,0,.22-.12.44-.16.66l-.18.86,12.79,7.43C188.65,203.64,188.77,203.14,188.89,202.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.79,174.17c1.08-1.35,2.2-2.63,3.35-3.88l.35-.39h0c.42-.44.85-.87,1.29-1.31l.53-.54h0c.76-.75,1.54-1.48,2.34-2.18l-12.79-7.43c-.79.7-1.57,1.43-2.34,2.18l-.21.2c-.36.35-.71.72-1.06,1.09l-.55.56c-.6.64-1.2,1.3-1.78,2l0,0c-.64.74-1.27,1.5-1.88,2.27h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.55 204.15 175.76 196.72 166.77 204.64 179.56 212.07 188.55 204.15",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.56 212.07 166.77 204.64 166.81 217.11 178.33 223.8 179.59 224.54 179.56 212.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.99 154.16 200.21 146.73 197.86 158.44 210.65 165.87 212.99 154.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.84 147.9 222.54 147.14 211.06 140.47 200.21 146.73 212.99 154.16 223.84 147.9",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.08 186.68 174.29 179.25 179.01 185.8 191.79 193.23 187.08 186.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.79 174.17 190 166.74 190 166.74 181.94 166 194.73 173.43 202.79 174.17",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.73 173.43 181.94 166 174.29 179.25 187.08 186.68 194.73 173.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.54,187.48l9-7.94,0-12.47-9,2.47a21.29,21.29,0,0,0-3.3-7.14l.79-2,3.88-9.95-7.7-4.39-8,10.05-.34,0-.86,0c-.36,0-.73,0-1.1,0h-.28a23.77,23.77,0,0,0-5.29.83l-1.7-6.33-.71-2.63L213,154.16l-2.34,11.71c-.8.7-1.58,1.43-2.34,2.18l-.53.54c-.44.44-.87.87-1.29,1.31l-.35.39c-1.15,1.25-2.27,2.53-3.35,3.88l-8.06-.74-7.65,13.25,4.71,6.55q-1.18,3-2,6.07c-.11.37-.21.74-.31,1.11q-.3,1.11-.54,2.22c-.12.51-.24,1-.34,1.52l-9,7.92,0,12.47,2.89-.79,6.12-1.67a20.74,20.74,0,0,0,3.3,7.14l-4.67,12,7.7,4.39,6.83-8.53,1.21-1.5a21.47,21.47,0,0,0,7.87-.79l2.41,9,10.85-6.27,2.34-11.71a63.81,63.81,0,0,0,7.85-8.28l8.07.72L250,204.94l-4.71-6.55A64.19,64.19,0,0,0,248.54,187.48Zm-15.24,1.9c0,.36-.08.71-.13,1.07s-.12.79-.2,1.19-.1.54-.16.81-.12.51-.19.76-.18.71-.28,1.07c-.06.2-.12.4-.19.61-.12.4-.25.79-.4,1.19-.05.16-.11.33-.17.49-.21.55-.42,1.09-.66,1.63l-.09.2c-.21.48-.44,1-.68,1.44-.07.15-.15.3-.22.44-.23.45-.47.9-.72,1.34l-.15.26c-.3.52-.62,1-.94,1.53l-.29.43c-.24.36-.48.71-.74,1.06l-.41.57-.67.86-.58.7-.57.65c-.33.36-.65.71-1,1l-.63.63-.5.46c-.12.12-.25.23-.38.34-.48.42-1,.82-1.46,1.19l-.44.34L220,212c-.47.32-.94.62-1.42.9a18.1,18.1,0,0,1-1.7.86l-.73.3c-.36.13-.71.26-1.06.36s-.43.13-.65.18a6,6,0,0,1-.61.13l-.77.12-.46,0c-.31,0-.61,0-.91,0h-.26a9.55,9.55,0,0,1-1.09-.13l-.25-.06a6.89,6.89,0,0,1-.81-.23l-.27-.1a6.92,6.92,0,0,1-1-.44h0c-2.29-1.31-3.83-3.89-4.26-7.5a17,17,0,0,1-.14-2.07c0-9.43,6.63-21,14.84-25.69a18.38,18.38,0,0,1,2-1c3.58-1.51,6.75-1.32,9.06.29.15.1.31.2.45.31s.31.29.46.44.27.24.39.38.28.36.41.53.23.29.34.45.24.42.35.63l.28.5c.11.23.19.49.29.74s.15.35.21.54.15.56.22.85.11.37.15.57.11.69.15,1c0,.18.06.34.08.52,0,.55.08,1.11.08,1.7S233.37,188.65,233.3,189.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,235.54l-1.21,1.5,11.49,6.68-2.41-9A21.47,21.47,0,0,1,203,235.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.49,169.54l9-2.47L246,160.38l-.79,2A21.29,21.29,0,0,1,248.49,169.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.26,185c0-.35-.08-.71-.15-1s-.1-.38-.15-.57-.13-.58-.22-.85-.14-.36-.21-.54-.18-.51-.29-.74l-.28-.5c-.11-.21-.22-.43-.35-.63s-.23-.3-.34-.45-.26-.36-.41-.53-.26-.25-.39-.38-.3-.3-.46-.44-.3-.21-.45-.31c-2.31-1.61-5.48-1.8-9.06-.29a17,17,0,0,1,.13,2.06c0,.54,0,1.09-.06,1.64,0,.17,0,.35,0,.53,0,.35-.08.7-.13,1.06s-.13.79-.21,1.19-.1.54-.16.81-.12.51-.18.76-.18.71-.29,1.06l-.18.62c-.13.4-.26.79-.4,1.19l-.18.49c-.2.55-.42,1.09-.66,1.64a1.42,1.42,0,0,0-.08.18c-.22.49-.45,1-.68,1.44l-.23.45c-.23.45-.47.9-.72,1.33l-.15.27c-.3.52-.61,1-.94,1.53-.09.14-.19.28-.28.43-.24.36-.49.71-.74,1.06l-.42.57c-.22.29-.44.57-.67.85s-.38.48-.58.71l-.57.64c-.32.37-.65.72-1,1.06l-.63.63-.5.47c-.27.25-.55.49-.84.73l-.5.42c-.31.25-.62.48-.94.7l-.45.33c-.46.32-.94.62-1.41.9s-.92.49-1.36.71l-.36.16-.29.12c.43,3.61,2,6.19,4.26,7.5h0a6.92,6.92,0,0,0,1,.44l.22.08,0,0a6.89,6.89,0,0,0,.81.23l.22,0h0a9.55,9.55,0,0,0,1.09.13h.26c.3,0,.6,0,.91,0l.43,0h0l.77-.12.6-.12h0c.22-.05.44-.11.65-.18a10.86,10.86,0,0,0,1.05-.36h0l.73-.3.34-.15c.45-.22.9-.44,1.36-.71s.95-.58,1.42-.9l.45-.32.44-.34.49-.37.51-.42.46-.4c.13-.11.26-.22.38-.34l.5-.46.63-.63c.34-.34.66-.69,1-1l.57-.65h0l.58-.7h0l.67-.86h0c.14-.18.28-.37.41-.56h0c.26-.35.5-.7.74-1.06h0l.29-.43h0c.32-.5.64-1,.94-1.53h0l.15-.26h0c.25-.44.49-.89.72-1.34h0c.07-.14.15-.29.22-.44.24-.48.47-1,.68-1.44h0l.09-.2h0c.24-.54.45-1.08.66-1.63.06-.16.11-.33.17-.49.15-.4.28-.79.4-1.19h0c.07-.21.13-.41.19-.61.1-.36.19-.71.28-1.07h0c.07-.25.13-.5.19-.76h0c.06-.27.11-.54.16-.81h0c.08-.4.15-.79.2-1.19h0c.05-.36.1-.71.13-1.07,0-.17,0-.35,0-.52.05-.55.07-1.1.07-1.64s0-1.15-.08-1.7C233.32,185.34,233.28,185.18,233.26,185Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.48 223.75 179.59 224.54 178.33 223.8 174.44 233.75 187.23 241.18 191.9 229.22 182.48 223.75",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.6,222.08l-6.12,1.67,9.42,5.47A20.74,20.74,0,0,1,188.6,222.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.25,156.86a23.77,23.77,0,0,1,5.29-.83h.28c.37,0,.74,0,1.1,0h0l.86,0,.34,0-9.57-5.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.89,202.63h0q.24-1.11.54-2.22h0c.1-.37.2-.74.31-1.11h0q.87-3,2-6.07L179,185.8c-.08.19-.15.37-.22.56s-.22.62-.33.93c-.2.54-.4,1.08-.59,1.62l-.12.36c-.09.26-.16.52-.25.78-.19.61-.38,1.22-.55,1.82,0,.17-.11.34-.15.5s-.1.4-.15.6c-.2.75-.38,1.49-.55,2.23,0,.22-.12.44-.16.66l-.18.86,12.79,7.43C188.65,203.64,188.77,203.14,188.89,202.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.56 212.07 166.77 204.64 166.81 217.11 178.33 223.8 179.59 224.54 179.56 212.07",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.99 154.16 200.21 146.73 197.86 158.44 210.65 165.87 212.99 154.16",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.08 186.68 174.29 179.25 179.01 185.8 191.79 193.23 187.08 186.68",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.79 174.17 190 166.74 190 166.74 181.94 166 194.73 173.43 202.79 174.17",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.55 150.53 234.12 156.09 242.16 146.04 229.37 138.61 222.54 147.14 223.84 147.9 224.55 150.53",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.79,174.17c1.08-1.35,2.2-2.63,3.35-3.88l.35-.39h0c.42-.44.85-.87,1.29-1.31l.53-.54h0c.76-.75,1.54-1.48,2.34-2.18l-12.79-7.43c-.79.7-1.57,1.43-2.34,2.18l-.21.2c-.36.35-.71.72-1.06,1.09l-.55.56c-.6.64-1.2,1.3-1.78,2l0,0c-.64.74-1.27,1.5-1.88,2.27h0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.55 204.15 175.76 196.72 166.77 204.64 179.56 212.07 188.55 204.15",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.84 147.9 222.54 147.14 211.06 140.47 200.21 146.73 212.99 154.16 223.84 147.9",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.73 173.43 181.94 166 174.29 179.25 187.08 186.68 194.73 173.43",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.1,126.76c.23-.14.46-.06.5.2a1,1,0,0,1-.28.82l-2.78,3.5,3.18-1.05c.2-.06.4-.06.44.23a1,1,0,0,1-.4.91l-.07,0a.79.79,0,0,1-.19.09l-3.68,1.05c-.28.08-.5,0-.54-.27l0-.05a1.37,1.37,0,0,1,.36-1l3.16-4.2a1.18,1.18,0,0,1,.25-.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,123.6a4.46,4.46,0,0,1-1.7,4,.47.47,0,0,1-.12.09c-.23.13-.42.07-.47-.17l-.64-2.82a2.6,2.6,0,0,0-.83,2.24.89.89,0,0,0,.63.74c.08,0,.12.07.15.19a.84.84,0,0,1-.32.75l-.09.07a.42.42,0,0,1-.25.06,1.29,1.29,0,0,1-.95-1.14,5,5,0,0,1,2.37-4.66C295.78,122.3,296.71,122.5,297,123.6Zm-1.74,2.8a2.48,2.48,0,0,0,.91-2.12c-.13-.58-.62-.67-1.25-.3l-.18.1.52,2.32",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.11,213.68c0-.36,0-.72,0-1.09,0-.2,0-.41,0-.62,0-.42-.09-.83-.14-1.25,0-.12,0-.24,0-.36s0,0,0-.06,0-.14,0-.21c-.06-.39-.15-.76-.24-1.13l-.09-.37-.09-.34c0-.12-.09-.24-.13-.36-.1-.32-.2-.62-.32-.92,0-.11-.07-.21-.11-.31s-.11-.22-.16-.33-.19-.43-.3-.63l-.15-.33c-.12-.22-.24-.43-.37-.64l-3.53-4c.19.31.36.64.52,1h0c-.16-.33-.33-.66-.52-1l-14.47,19.66-7.68.86-1.38-4.11-3.53-4L366.07,193c-8.7-1.22-19.51,4.15-25.74,12.6s-4,14.8.74,21.35L279.78,310.2c-6.55-.29-12.74,1.74-17.34,8s-5.38,13.69-2.44,18.88l3.53,4,9.73-13.22,7.68-.86,1.38,4.11L273,343.74h0l3.53,4c.39,0,.79,0,1.18-.08l.41-.06.78-.11.48-.1.72-.15.51-.13.68-.19.1,0,.6-.2.42-.14c.29-.1.57-.22.85-.33l.27-.11h0l.06,0c.49-.21,1-.44,1.45-.68l.2-.1a1.18,1.18,0,0,0,.19-.11c.37-.19.72-.39,1.08-.61l.21-.12.06,0c.41-.25.81-.52,1.21-.8l.05,0,.25-.19c.28-.21.56-.42.83-.64l.13-.09.29-.25.66-.57.19-.16.24-.23.61-.59.23-.22.17-.19c.21-.22.41-.45.61-.68l.26-.27a.64.64,0,0,1,.1-.13c.26-.31.51-.63.75-.95l.16-.2.06-.08c.3-.4.57-.81.83-1.21l.07-.11.12-.2c.23-.38.45-.76.64-1.14l.12-.2.06-.14c.1-.19.18-.38.27-.57s.14-.32.2-.48.15-.39.22-.58.1-.25.14-.37l0-.09c.06-.18.1-.36.15-.54s.1-.32.14-.48.07-.36.11-.53.07-.32.09-.47.05-.36.08-.54,0-.31.05-.46,0-.36,0-.54,0-.27,0-.4,0,0,0,0a11,11,0,0,0,0-1.15,3,3,0,0,0,0-.31,8.39,8.39,0,0,0-.1-.86c0-.06,0-.12,0-.19s0-.14,0-.21-.07-.38-.11-.57-.06-.29-.1-.44l-.15-.58c0-.09-.05-.19-.08-.28a.65.65,0,0,0,0-.13c-.07-.23-.15-.47-.23-.7s-.07-.22-.11-.33q-.18-.51-.39-1l62.21-84.5,1.51.08h.46l1,0h1.44l.58,0,.82,0,.6,0,.78-.06.6-.09.74-.1.6-.12.71-.15.59-.16.53-.14.13,0c.51-.16,1-.34,1.51-.55h.05l.63-.3c.18-.08.36-.16.55-.26l0,0c.34-.18.68-.37,1-.58l.06,0L373,235c.21-.14.43-.27.64-.42l.22-.17.33-.25.34-.26.44-.38.3-.26.14-.12c.29-.26.57-.54.86-.83l.06-.06h0c.33-.35.67-.71,1-1.1l.05-.07c.23-.27.46-.56.68-.85l.42-.52.06-.1c.41-.55.79-1.11,1.15-1.68l.09-.13q.39-.62.75-1.26l.1-.2q.28-.49.54-1l.09-.2c.24-.49.46-1,.67-1.47l.16-.36c.25-.61.48-1.23.69-1.84a1,1,0,0,1,0-.1l.14-.5c.12-.39.24-.79.35-1.18.06-.23.11-.46.16-.7s.17-.72.24-1.08l.12-.73c.05-.35.1-.7.14-1s.06-.49.08-.73.05-.69.06-1l0-.45C384.12,213.85,384.11,213.77,384.11,213.68Zm-3.55-5.11h0l0-.63h0Zm-.17-1.86h0c0-.15,0-.29-.06-.44h0C380.36,206.42,380.37,206.56,380.39,206.71Zm-1.24-4.4c.1.21.18.42.27.64h0c-.09-.22-.17-.43-.27-.64ZM290.94,302.66a2.46,2.46,0,0,0,0,.28C291,302.85,291,302.76,290.94,302.66Zm0-.47,0-.28,0,.26ZM341.65,234h-.06a3.94,3.94,0,0,1,.47-.1Zm-.89.34.1,0Zm-.74.44h0Zm-48.63,69.42,0,0Zm54-69.41-.08-.07h0l0,0ZM344,234a3.26,3.26,0,0,1,.72.31A3.26,3.26,0,0,0,344,234Zm-.28-.05a2.75,2.75,0,0,0-.5-.09h0A3,3,0,0,1,343.75,233.94Zm-.85-.09h0c-.16,0-.31,0-.46,0A3.85,3.85,0,0,1,342.9,233.85Zm-3.55,1.52-.05,0Zm-48.24,68.26a.25.25,0,0,0,0-.07A.25.25,0,0,1,291.11,303.63Zm0-2.22c0-.06,0-.13.05-.2S291.09,301.35,291.07,301.41Zm.33-.91s0,0,0-.05S291.41,300.48,291.4,300.5Zm-16,43,.12,0-.12,0Zm2.39-.57h0l.7-.23h0Zm1.12-.37h0l.5-.2Zm2.65-1.16.17-.09-.17.09Zm1.47-.82h0l.27-.16h0Zm1.71-1.13a.18.18,0,0,1,.07-.05h0Zm2.39-2h0Zm3.8-4.53h0c.06-.1.12-.21.19-.31h0C291,332.72,291,332.83,290.92,332.93Zm.93-1.64a1.09,1.09,0,0,0,.08-.15h0A1.09,1.09,0,0,1,291.85,331.29Zm.57-12h0v0Zm.85,7.8s0-.05,0-.07h0S293.27,327.08,293.27,327.1Zm.09-.61h0c0-.15,0-.31.05-.46h0C293.4,326.18,293.37,326.34,293.36,326.49Zm-.12-4.15.06.39h0Zm.16,1.25h0c0,.1,0,.2,0,.3h0A3,3,0,0,0,293.4,323.59Zm67.27-89.81h0l.78-.07h0Zm1.38-.15h0l.75-.1h0Zm2.64-.53h0l.66-.19h0Zm2.58-.93.27-.12h0Zm5.16-3.59c.09-.1.19-.18.28-.28h0Zm1.08-1.15c.11-.12.22-.23.32-.36h0C373.73,227.2,373.62,227.31,373.51,227.43Zm1-1.21h0c.16-.2.32-.4.48-.62h0C374.83,225.82,374.67,226,374.51,226.22Zm3.12-4.93a1.09,1.09,0,0,1,.08-.15h0A1.09,1.09,0,0,0,377.63,221.29Zm1.6-3.82c0-.09,0-.18.08-.27,0,.09-.05.18-.08.27Zm.93-3.56c0-.11,0-.22,0-.33,0,.11,0,.22,0,.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.26 213.1 354.8 217.12 357.61 225.48 354.08 221.46 351.26 213.1",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "351.26 213.1 354.8 217.12 357.61 225.48 354.08 221.46 351.26 213.1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M383.45,219q.14-.54.24-1.08l.12-.73c.05-.35.1-.7.14-1s.06-.49.08-.73.05-.69.06-1l0-.45c0-.09,0-.17,0-.26,0-.36,0-.72,0-1.09,0-.2,0-.41,0-.62,0-.42-.09-.83-.14-1.25,0-.12,0-.24,0-.36s0,0,0-.06,0-.14,0-.21c-.07-.39-.15-.76-.24-1.13l-.09-.37-.09-.34c0-.12-.09-.24-.13-.36-.1-.32-.2-.62-.32-.92,0-.11-.07-.21-.11-.31l-.16-.33c-.09-.21-.19-.43-.3-.63l-.15-.33c-.12-.22-.24-.43-.37-.64l-3.53-4c.19.31.36.64.52,1a6.09,6.09,0,0,1,.3.63c.1.21.18.42.27.64s.22.6.32.91.15.47.22.71l.09.37a10.8,10.8,0,0,1,.24,1.13,1.77,1.77,0,0,1,0,.2c0,.15,0,.29.06.44.05.41.11.82.14,1.24l0,.62c0,.37,0,.73,0,1.09s0,.47,0,.71,0,.68-.06,1-.05.49-.08.73-.09.7-.14,1.05l-.12.73q-.11.54-.24,1.08c-.05.23-.1.47-.16.7-.11.39-.23.79-.35,1.18-.06.2-.11.4-.18.6-.21.61-.44,1.23-.69,1.84l-.16.36c-.21.49-.43,1-.67,1.47s-.41.8-.63,1.19a1.86,1.86,0,0,1-.1.2c-.26.47-.55.93-.84,1.38s-.74,1.14-1.15,1.69c-.16.22-.32.42-.48.62s-.45.58-.68.85c-.35.42-.7.81-1.06,1.18l-.06.06c-.33.33-.66.65-1,.95l-.3.26c-.26.22-.52.44-.78.64l-.33.25-.86.59-.23.15c-.37.23-.75.45-1.12.64-.19.1-.37.18-.56.26s-.44.22-.67.31c-.5.21-1,.39-1.51.55l-.66.19-.59.16-.71.15-.6.12-.74.1-.6.08-.78.07-.6.05-.82,0-.58,0c-.3,0-.6,0-.9,0s-.36,0-.54,0l-1,0-.46,0-1.51-.07,3.53,4,1.51.08h.46l1,0h1.44l.58,0,.82,0,.6,0,.78-.06.6-.09.74-.1.6-.12.71-.15.59-.16.53-.14.13,0c.51-.16,1-.34,1.51-.55h.05l.63-.3c.18-.08.36-.16.55-.26l0,0c.34-.18.68-.37,1-.58l.06,0L373,235c.21-.14.43-.27.64-.42l.22-.17.33-.25.34-.26.44-.38.3-.26.14-.12c.29-.26.57-.54.86-.83l.06-.06h0c.33-.35.67-.71,1-1.1l.05-.07c.23-.27.46-.56.68-.85l.42-.52.06-.1c.41-.55.79-1.11,1.15-1.68l.09-.13q.39-.62.75-1.26a1.24,1.24,0,0,0,.1-.2q.28-.49.54-1l.09-.2c.24-.49.46-1,.67-1.47l.16-.36c.25-.61.48-1.23.69-1.84a1,1,0,0,1,0-.1l.14-.5c.12-.39.24-.79.35-1.18C383.35,219.48,383.4,219.25,383.45,219Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.45,219q.14-.54.24-1.08l.12-.73c.05-.35.1-.7.14-1s.06-.49.08-.73.05-.69.06-1l0-.45c0-.09,0-.17,0-.26,0-.36,0-.72,0-1.09,0-.2,0-.41,0-.62,0-.42-.09-.83-.14-1.25,0-.12,0-.24,0-.36s0,0,0-.06,0-.14,0-.21c-.07-.39-.15-.76-.24-1.13l-.09-.37-.09-.34c0-.12-.09-.24-.13-.36-.1-.32-.2-.62-.32-.92,0-.11-.07-.21-.11-.31l-.16-.33c-.09-.21-.19-.43-.3-.63l-.15-.33c-.12-.22-.24-.43-.37-.64l-3.53-4c.19.31.36.64.52,1a6.09,6.09,0,0,1,.3.63c.1.21.18.42.27.64s.22.6.32.91.15.47.22.71l.09.37a10.8,10.8,0,0,1,.24,1.13,1.77,1.77,0,0,1,0,.2c0,.15,0,.29.06.44.05.41.11.82.14,1.24l0,.62c0,.37,0,.73,0,1.09s0,.47,0,.71,0,.68-.06,1-.05.49-.08.73-.09.7-.14,1.05l-.12.73q-.11.54-.24,1.08c-.05.23-.1.47-.16.7-.11.39-.23.79-.35,1.18-.06.2-.11.4-.18.6-.21.61-.44,1.23-.69,1.84l-.16.36c-.21.49-.43,1-.67,1.47s-.41.8-.63,1.19a1.86,1.86,0,0,1-.1.2c-.26.47-.55.93-.84,1.38s-.74,1.14-1.15,1.69c-.16.22-.32.42-.48.62s-.45.58-.68.85c-.35.42-.7.81-1.06,1.18l-.06.06c-.33.33-.66.65-1,.95l-.3.26c-.26.22-.52.44-.78.64l-.33.25-.86.59-.23.15c-.37.23-.75.45-1.12.64-.19.1-.37.18-.56.26s-.44.22-.67.31c-.5.21-1,.39-1.51.55l-.66.19-.59.16-.71.15-.6.12-.74.1-.6.08-.78.07-.6.05-.82,0-.58,0c-.3,0-.6,0-.9,0s-.36,0-.54,0l-1,0-.46,0-1.51-.07,3.53,4,1.51.08h.46l1,0h1.44l.58,0,.82,0,.6,0,.78-.06.6-.09.74-.1.6-.12.71-.15.59-.16.53-.14.13,0c.51-.16,1-.34,1.51-.55h.05l.63-.3c.18-.08.36-.16.55-.26l0,0c.34-.18.68-.37,1-.58l.06,0L373,235c.21-.14.43-.27.64-.42l.22-.17.33-.25.34-.26.44-.38.3-.26.14-.12c.29-.26.57-.54.86-.83l.06-.06h0c.33-.35.67-.71,1-1.1l.05-.07c.23-.27.46-.56.68-.85l.42-.52.06-.1c.41-.55.79-1.11,1.15-1.68l.09-.13q.39-.62.75-1.26a1.24,1.24,0,0,0,.1-.2q.28-.49.54-1l.09-.2c.24-.49.46-1,.67-1.47l.16-.36c.25-.61.48-1.23.69-1.84a1,1,0,0,1,0-.1l.14-.5c.12-.39.24-.79.35-1.18C383.35,219.48,383.4,219.25,383.45,219Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,238.83h0a6.52,6.52,0,0,1,.72-.43l.1,0a6.52,6.52,0,0,1,.73-.29,4.1,4.1,0,0,1,.48-.1c.11,0,.23-.06.35-.07s.32,0,.49,0h.33a3,3,0,0,1,.51.09,2.16,2.16,0,0,1,.27,0,3.64,3.64,0,0,1,.73.31l.14.1a3,3,0,0,1,.64.53l-2-2.28-1.52-1.74-.19-.18a3.28,3.28,0,0,0-.59-.45h0A3.14,3.14,0,0,0,344,234a2.16,2.16,0,0,0-.27-.05,3,3,0,0,0-.51-.09h-.33a3.93,3.93,0,0,0-.49,0c-.12,0-.24,0-.35.07a4.1,4.1,0,0,0-.48.1h0a5.17,5.17,0,0,0-.51.18l-.2.1-.1,0-.1,0-.35.2a2.11,2.11,0,0,0-.27.18h0l-.28.21-.27.23-.11.11-.05,0-.09.09a2.16,2.16,0,0,0-.25.27l-.24.3,0,0-46.8,63.57-.23.34-.13.23c0,.05-.05.09-.07.13l-.05.08-.11.27a3.65,3.65,0,0,0-.14.35l0,.06c0,.11-.05.22-.08.33s-.05.17-.06.25a3.87,3.87,0,0,0-.06.46,1.23,1.23,0,0,1,0,.19v0a1.49,1.49,0,0,0,0,.21,3.1,3.1,0,0,0,0,.43.06.06,0,0,1,0,0,3.29,3.29,0,0,0,.09.43l0,.07,0,.09.06.17c0,.1.09.19.14.29l0,0,0,0,.1.17c0,.08.11.15.17.23l.07.07,3.53,4a3.21,3.21,0,0,1-.34-.48l0,0a3.16,3.16,0,0,1-.22-.5l0-.09a3,3,0,0,1-.13-.54,3.17,3.17,0,0,1,0-.44,1.5,1.5,0,0,1,0-.22,1.23,1.23,0,0,0,0-.19,3.47,3.47,0,0,1,.06-.45,2.44,2.44,0,0,1,.06-.26,2.85,2.85,0,0,1,.11-.39,3.65,3.65,0,0,1,.14-.35c.05-.12.1-.23.16-.35s.05-.08.07-.13.23-.38.36-.57l46.8-63.57a7.87,7.87,0,0,1,.6-.68l.05-.05A7.1,7.1,0,0,1,343.55,238.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,238.83h0a6.52,6.52,0,0,1,.72-.43l.1,0a6.52,6.52,0,0,1,.73-.29,4.1,4.1,0,0,1,.48-.1c.11,0,.23-.06.35-.07s.32,0,.49,0h.33a3,3,0,0,1,.51.09,2.16,2.16,0,0,1,.27,0,3.64,3.64,0,0,1,.73.31l.14.1a3,3,0,0,1,.64.53l-2-2.28-1.52-1.74-.19-.18a3.28,3.28,0,0,0-.59-.45h0A3.14,3.14,0,0,0,344,234a2.16,2.16,0,0,0-.27-.05,3,3,0,0,0-.51-.09h-.33a3.93,3.93,0,0,0-.49,0c-.12,0-.24,0-.35.07a4.1,4.1,0,0,0-.48.1h0a5.17,5.17,0,0,0-.51.18l-.2.1-.1,0-.1,0-.35.2a2.11,2.11,0,0,0-.27.18h0l-.28.21-.27.23-.11.11-.05,0-.09.09a2.16,2.16,0,0,0-.25.27l-.24.3,0,0-46.8,63.57-.23.34-.13.23c0,.05-.05.09-.07.13l-.05.08-.11.27a3.65,3.65,0,0,0-.14.35l0,.06c0,.11-.05.22-.08.33s-.05.17-.06.25a3.87,3.87,0,0,0-.06.46,1.23,1.23,0,0,1,0,.19v0a1.49,1.49,0,0,0,0,.21,3.1,3.1,0,0,0,0,.43.06.06,0,0,1,0,0,3.29,3.29,0,0,0,.09.43l0,.07,0,.09.06.17c0,.1.09.19.14.29l0,0,0,0,.1.17c0,.08.11.15.17.23l.07.07,3.53,4a3.21,3.21,0,0,1-.34-.48l0,0a3.16,3.16,0,0,1-.22-.5l0-.09a3,3,0,0,1-.13-.54,3.17,3.17,0,0,1,0-.44,1.5,1.5,0,0,1,0-.22,1.23,1.23,0,0,0,0-.19,3.47,3.47,0,0,1,.06-.45,2.44,2.44,0,0,1,.06-.26,2.85,2.85,0,0,1,.11-.39,3.65,3.65,0,0,1,.14-.35c.05-.12.1-.23.16-.35s.05-.08.07-.13.23-.38.36-.57l46.8-63.57a7.87,7.87,0,0,1,.6-.68l.05-.05A7.1,7.1,0,0,1,343.55,238.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,238.83h0a6.52,6.52,0,0,1,.72-.43l.1,0a6.52,6.52,0,0,1,.73-.29,4.1,4.1,0,0,1,.48-.1c.11,0,.23-.06.35-.07s.32,0,.49,0h.33a3,3,0,0,1,.51.09,2.16,2.16,0,0,1,.27,0,3.64,3.64,0,0,1,.73.31l.14.1a3,3,0,0,1,.64.53l-2-2.28-1.52-1.74-.19-.18a3.28,3.28,0,0,0-.59-.45h0A3.14,3.14,0,0,0,344,234a2.16,2.16,0,0,0-.27-.05,3,3,0,0,0-.51-.09h-.33a3.93,3.93,0,0,0-.49,0c-.12,0-.24,0-.35.07a4.1,4.1,0,0,0-.48.1h0a5.17,5.17,0,0,0-.51.18l-.2.1-.1,0-.1,0-.35.2a2.11,2.11,0,0,0-.27.18h0l-.28.21-.27.23-.11.11-.05,0-.09.09a2.16,2.16,0,0,0-.25.27l-.24.3,0,0-46.8,63.57-.23.34-.13.23c0,.05-.05.09-.07.13l-.05.08-.11.27a3.65,3.65,0,0,0-.14.35l0,.06c0,.11-.05.22-.08.33s-.05.17-.06.25a3.87,3.87,0,0,0-.06.46,1.23,1.23,0,0,1,0,.19v0a1.49,1.49,0,0,0,0,.21,3.1,3.1,0,0,0,0,.43.06.06,0,0,1,0,0,3.29,3.29,0,0,0,.09.43l0,.07,0,.09.06.17c0,.1.09.19.14.29l0,0,0,0,.1.17c0,.08.11.15.17.23l.07.07,3.53,4a3.21,3.21,0,0,1-.34-.48l0,0a3.16,3.16,0,0,1-.22-.5l0-.09a3,3,0,0,1-.13-.54,3.17,3.17,0,0,1,0-.44,1.5,1.5,0,0,1,0-.22,1.23,1.23,0,0,0,0-.19,3.47,3.47,0,0,1,.06-.45,2.44,2.44,0,0,1,.06-.26,2.85,2.85,0,0,1,.11-.39,3.65,3.65,0,0,1,.14-.35c.05-.12.1-.23.16-.35s.05-.08.07-.13.23-.38.36-.57l46.8-63.57a7.87,7.87,0,0,1,.6-.68l.05-.05A7.1,7.1,0,0,1,343.55,238.83Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.73 323.84 273.26 327.86 263.53 341.08 260 337.06 269.73 323.84",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "269.73 323.84 273.26 327.86 263.53 341.08 260 337.06 269.73 323.84"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "345.33 239.93 348.86 243.95 302.06 307.52 298.53 303.5 345.33 239.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--svgid--inject-2",
    d: "M295.24,308.69l-3.53-4a3,3,0,0,0,.77.64c1.83,1.05,4.54.24,6-1.8l3.53,4c-1.51,2-4.22,2.85-6.05,1.8A3.21,3.21,0,0,1,295.24,308.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.53,303.5l3.53,4v0l-3.53-4h0",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.52,303.51l3.53,4-.24.3-3.53-4,.24-.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.28,303.82l3.53,4-.25.27-3.53-4,.25-.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,304.09l3.53,4-.25.24-3.53-4,.25-.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.78,304.33l3.53,4-.26.23-3.53-4,.26-.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.52,304.56l3.53,4-.29.21-3.53-4,.29-.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.23,304.77l3.53,4-.3.21-3.53-4,.3-.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.93,305l3.53,4-.35.19-3.53-4,.35-.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.58,305.17l3.53,4a3.62,3.62,0,0,1-.4.19l-3.53-4,.4-.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.18,305.36l3.53,4a4.6,4.6,0,0,1-.52.19l-3.53-4a4.6,4.6,0,0,0,.52-.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.66,305.55l3.53,4a4,4,0,0,1-3.18-.25,3.21,3.21,0,0,1-.77-.63l-3.53-4a3,3,0,0,0,.77.64,4,4,0,0,0,3.18.25",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M345.94,235.18c1.83,1,2.09,3.57.58,5.63l-46.8,63.56c-1.51,2.05-4.22,2.86-6.05,1.81s-2.09-3.58-.58-5.63L339.89,237C341.4,234.93,344.11,234.12,345.94,235.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M345.94,235.18c1.83,1,2.09,3.57.58,5.63l-46.8,63.56c-1.51,2.05-4.22,2.86-6.05,1.81s-2.09-3.58-.58-5.63L339.89,237C341.4,234.93,344.11,234.12,345.94,235.18Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "279.51 322.74 283.04 326.76 273.26 327.86 269.73 323.84 279.51 322.74",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "279.51 322.74 283.04 326.76 273.26 327.86 269.73 323.84 279.51 322.74"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "354.24 233.78 357.77 237.8 295.56 322.3 292.03 318.28 354.24 233.78",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "354.24 233.78 357.77 237.8 295.56 322.3 292.03 318.28 354.24 233.78"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M375,225.6c-5.85,8-12.44,8.68-20.75,8.18L292,318.28c2.1,5.05,2.25,10.17-1.94,15.86s-10.93,9.35-17.07,9.6l9.3-12.63-2.81-8.37-9.78,1.1L260,337.06c-2.94-5.19-2.15-12.64,2.44-18.88s10.79-8.27,17.34-8l61.29-83.26c-4.76-6.55-7-12.89-.74-21.35s17-13.82,25.74-12.6l-14.8,20.11,2.81,8.36,9.78-1.09,14.47-19.66C382.33,207.24,380.9,217.59,375,225.6Zm-76.46,77.9,46.8-63.57c1.51-2.06,1.25-4.58-.58-5.63s-4.53-.25-6.05,1.8l-46.8,63.57c-1.5,2.05-1.25,4.57.58,5.63s4.54.24,6-1.8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,225.6c-5.85,8-12.44,8.68-20.75,8.18L292,318.28c2.1,5.05,2.25,10.17-1.94,15.86s-10.93,9.35-17.07,9.6l9.3-12.63-2.81-8.37-9.78,1.1L260,337.06c-2.94-5.19-2.15-12.64,2.44-18.88s10.79-8.27,17.34-8l61.29-83.26c-4.76-6.55-7-12.89-.74-21.35s17-13.82,25.74-12.6l-14.8,20.11,2.81,8.36,9.78-1.09,14.47-19.66C382.33,207.24,380.9,217.59,375,225.6Zm-76.46,77.9,46.8-63.57c1.51-2.06,1.25-4.58-.58-5.63s-4.53-.25-6.05,1.8l-46.8,63.57c-1.5,2.05-1.25,4.57.58,5.63s4.54.24,6-1.8",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,225.6c-5.85,8-12.44,8.68-20.75,8.18L292,318.28c2.1,5.05,2.25,10.17-1.94,15.86s-10.93,9.35-17.07,9.6l9.3-12.63-2.81-8.37-9.78,1.1L260,337.06c-2.94-5.19-2.15-12.64,2.44-18.88s10.79-8.27,17.34-8l61.29-83.26c-4.76-6.55-7-12.89-.74-21.35s17-13.82,25.74-12.6l-14.8,20.11,2.81,8.36,9.78-1.09,14.47-19.66C382.33,207.24,380.9,217.59,375,225.6Zm-76.46,77.9,46.8-63.57c1.51-2.06,1.25-4.58-.58-5.63s-4.53-.25-6.05,1.8l-46.8,63.57c-1.5,2.05-1.25,4.57.58,5.63s4.54.24,6-1.8",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.61,332.05c0-.18.07-.36.11-.53s.07-.32.09-.47.05-.36.08-.54,0-.31.05-.46,0-.36,0-.54l0-.4v0a11,11,0,0,0,0-1.15,3,3,0,0,0,0-.31,8.39,8.39,0,0,0-.1-.86c0-.06,0-.12,0-.19s0-.14,0-.21-.07-.38-.11-.57-.06-.29-.1-.44l-.15-.58c0-.09-.05-.19-.08-.28a.65.65,0,0,0,0-.13c-.07-.23-.15-.47-.23-.7s-.07-.22-.11-.33q-.18-.51-.39-1l-3.53-4q.21.51.39,1c0,.11.08.22.11.33s.16.47.23.7l.12.41.15.58c0,.15.07.29.1.44s.08.38.11.57l.06.4a8.08,8.08,0,0,1,.1.86c0,.1,0,.2,0,.3a11.23,11.23,0,0,1,0,1.16c0,.14,0,.29,0,.44s0,.36,0,.54,0,.31-.05.46-.05.36-.08.54-.06.31-.09.47-.07.35-.11.53-.09.32-.14.48-.09.36-.15.54-.11.3-.17.46-.14.38-.22.58-.13.31-.2.47-.17.39-.27.58-.12.22-.18.33c-.19.38-.41.77-.64,1.15-.07.1-.13.21-.19.31-.26.4-.53.81-.83,1.21-.07.1-.15.19-.22.28-.24.32-.49.64-.75.95l-.36.4c-.2.23-.4.46-.61.68l-.4.41-.61.59-.43.39c-.22.2-.44.38-.66.57l-.42.34c-.27.22-.55.43-.83.64l-.3.22c-.4.28-.8.55-1.21.8l-.27.16c-.35.21-.71.42-1.08.61l-.39.21c-.48.24-1,.47-1.45.68l-.08,0-.28.11-.84.33-.42.14-.7.23c-.22.07-.45.12-.68.18l-.51.14-.71.15-.49.1-.78.11-.41,0a11.71,11.71,0,0,1-1.18.09l3.53,4c.39,0,.79,0,1.18-.08l.41-.06.78-.11.48-.1.72-.15.51-.13.68-.19.1,0,.6-.2.42-.14c.29-.1.57-.22.85-.33l.27-.11h0l.06,0c.49-.21,1-.44,1.45-.68l.2-.1a1.18,1.18,0,0,0,.19-.11c.37-.19.72-.39,1.08-.61l.21-.12.06,0c.41-.25.81-.52,1.21-.8l.05,0,.25-.19c.28-.21.56-.42.83-.64l.13-.09.29-.25.66-.57.19-.16.24-.23.61-.59.23-.22.17-.19c.21-.22.41-.45.61-.68l.26-.27a.64.64,0,0,1,.1-.13c.26-.31.51-.63.75-.95l.16-.2.06-.08c.3-.4.57-.81.83-1.21l.07-.11.12-.2c.23-.38.45-.76.64-1.14l.12-.2.06-.14c.1-.19.18-.38.27-.57s.14-.32.2-.48.15-.39.22-.58.1-.25.14-.37l0-.09c.06-.18.1-.36.15-.54S296.57,332.21,296.61,332.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.61,332.05c0-.18.07-.36.11-.53s.07-.32.09-.47.05-.36.08-.54,0-.31.05-.46,0-.36,0-.54l0-.4v0a11,11,0,0,0,0-1.15,3,3,0,0,0,0-.31,8.39,8.39,0,0,0-.1-.86c0-.06,0-.12,0-.19s0-.14,0-.21-.07-.38-.11-.57-.06-.29-.1-.44l-.15-.58c0-.09-.05-.19-.08-.28a.65.65,0,0,0,0-.13c-.07-.23-.15-.47-.23-.7s-.07-.22-.11-.33q-.18-.51-.39-1l-3.53-4q.21.51.39,1c0,.11.08.22.11.33s.16.47.23.7l.12.41.15.58c0,.15.07.29.1.44s.08.38.11.57l.06.4a8.08,8.08,0,0,1,.1.86c0,.1,0,.2,0,.3a11.23,11.23,0,0,1,0,1.16c0,.14,0,.29,0,.44s0,.36,0,.54,0,.31-.05.46-.05.36-.08.54-.06.31-.09.47-.07.35-.11.53-.09.32-.14.48-.09.36-.15.54-.11.3-.17.46-.14.38-.22.58-.13.31-.2.47-.17.39-.27.58-.12.22-.18.33c-.19.38-.41.77-.64,1.15-.07.1-.13.21-.19.31-.26.4-.53.81-.83,1.21-.07.1-.15.19-.22.28-.24.32-.49.64-.75.95l-.36.4c-.2.23-.4.46-.61.68l-.4.41-.61.59-.43.39c-.22.2-.44.38-.66.57l-.42.34c-.27.22-.55.43-.83.64l-.3.22c-.4.28-.8.55-1.21.8l-.27.16c-.35.21-.71.42-1.08.61l-.39.21c-.48.24-1,.47-1.45.68l-.08,0-.28.11-.84.33-.42.14-.7.23c-.22.07-.45.12-.68.18l-.51.14-.71.15-.49.1-.78.11-.41,0a11.71,11.71,0,0,1-1.18.09l3.53,4c.39,0,.79,0,1.18-.08l.41-.06.78-.11.48-.1.72-.15.51-.13.68-.19.1,0,.6-.2.42-.14c.29-.1.57-.22.85-.33l.27-.11h0l.06,0c.49-.21,1-.44,1.45-.68l.2-.1a1.18,1.18,0,0,0,.19-.11c.37-.19.72-.39,1.08-.61l.21-.12.06,0c.41-.25.81-.52,1.21-.8l.05,0,.25-.19c.28-.21.56-.42.83-.64l.13-.09.29-.25.66-.57.19-.16.24-.23.61-.59.23-.22.17-.19c.21-.22.41-.45.61-.68l.26-.27a.64.64,0,0,1,.1-.13c.26-.31.51-.63.75-.95l.16-.2.06-.08c.3-.4.57-.81.83-1.21l.07-.11.12-.2c.23-.38.45-.76.64-1.14l.12-.2.06-.14c.1-.19.18-.38.27-.57s.14-.32.2-.48.15-.39.22-.58.1-.25.14-.37l0-.09c.06-.18.1-.36.15-.54S296.57,332.21,296.61,332.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.07 192.99 369.6 197.01 354.8 217.12 351.26 213.1 366.07 192.99",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "366.07 192.99 369.6 197.01 354.8 217.12 351.26 213.1 366.07 192.99"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M346,434.84c-.65,2.06-2.92,3.25-5.08,3.42a25.16,25.16,0,0,1-6.43-.83c-4.78-.86-9.39,0-14.15-.12a19.63,19.63,0,0,1-4.66-.5,7.73,7.73,0,0,1-4-2.35,5.13,5.13,0,0,1-1.14-2.49,4.88,4.88,0,0,0,1.14,3.89,7.73,7.73,0,0,0,4,2.35,20.16,20.16,0,0,0,4.66.5c4.76.11,9.37-.74,14.15.12a24.71,24.71,0,0,0,6.43.82c2.16-.17,4.43-1.35,5.08-3.42a5.43,5.43,0,0,0,.17-2.2A3.9,3.9,0,0,1,346,434.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.88,430.88c-.29-1.45-.59-2.9-.88-4.35a6.54,6.54,0,0,0-.73-2.21,2.21,2.21,0,0,0-1.94-1.1c-2.61-.35-6.29-1.3-8.47.2a19.49,19.49,0,0,1-11.7,3.4c-2.16-.08-4.33-.52-6.47-.26s-4.38,1.46-5,3.52a4.17,4.17,0,0,0-.11,1.89,5.13,5.13,0,0,0,1.14,2.49,7.73,7.73,0,0,0,4,2.35,19.63,19.63,0,0,0,4.66.5c4.76.12,9.37-.74,14.15.12a25.16,25.16,0,0,0,6.43.83c2.16-.17,4.43-1.36,5.08-3.42a3.9,3.9,0,0,0,.17-.81A10.18,10.18,0,0,0,345.88,430.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.23,418.87l-.19,5.66a2.24,2.24,0,0,0,2.08,2.31,36.08,36.08,0,0,0,5.7,0,3.21,3.21,0,0,0,2.91-3l.23-4.18Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.23,418.87l-.19,5.66a2.24,2.24,0,0,0,2.08,2.31,36.08,36.08,0,0,0,5.7,0,3.21,3.21,0,0,0,2.91-3l.23-4.18Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.15,415.87a3.78,3.78,0,0,1-3.42,3.83A6.75,6.75,0,0,1,360.1,417c-.71-1-1.11-2.24-1.78-3.3a15.2,15.2,0,0,0-3.72-3.61,15.76,15.76,0,0,1-3.74-3.59,5.27,5.27,0,0,1-.72-4.78,4.48,4.48,0,0,0-.35.6,5.45,5.45,0,0,0,.68,5.1,16.1,16.1,0,0,0,3.81,3.69,15.4,15.4,0,0,1,3.79,3.72c.69,1.09,1.1,2.34,1.83,3.4a6.84,6.84,0,0,0,6.76,2.81,4.24,4.24,0,0,0,2.72-1.55,5.2,5.2,0,0,0,.79-3.24C370.17,416.11,370.16,416,370.15,415.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.44,408.77c-1.72-3-5.26-5.21-8-7.34a10.25,10.25,0,0,0-5.3-2.41,5,5,0,0,0-4.94,2.52,1,1,0,0,1-.06.16,5.27,5.27,0,0,0,.72,4.78,15.76,15.76,0,0,0,3.74,3.59,15.2,15.2,0,0,1,3.72,3.61c.67,1.06,1.07,2.27,1.78,3.3a6.75,6.75,0,0,0,6.63,2.72,3.78,3.78,0,0,0,3.42-3.83,7.54,7.54,0,0,0,0-.82A13.16,13.16,0,0,0,368.44,408.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,406.15v5.14a8.63,8.63,0,0,0,8-.35l.48-4.63Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,406.15v5.14a8.63,8.63,0,0,0,8-.35l.48-4.63Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.81,312.9c1.55,4.62,1.07,28.87.17,50,1.47,10.25,1.42,32.47-.51,48.53,0,0-5.36,3-12.81.26l-4.55-48.76-1.05-25.05s-1.9,22.23-4.09,36.49c.8,10.47-.93,30.49-2.47,51.83,0,0-8.25,4.82-16.44-.45-2.87-47.2,1.79-95,2.74-110.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,331l1.51-9.35,1.45,9a21,21,0,0,0,10.87-4.47c-.07-6.53-.37-11.43-1-13.25l-39,2.31c-.17,2.73-.45,6.47-.79,11A49.67,49.67,0,0,0,358,331Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.7,353.08l-.86-20.43c5.29,0,10.19-3.95,13.91-7.69-3.58,6.38-10.52,9.2-10.52,9.2Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.13,246.28a25.38,25.38,0,0,0,8.24-15.48,8.72,8.72,0,0,0-.53-4.86c-.74-1.47-2.63-3-4.24-2.63a6.93,6.93,0,0,0-2.78-5.23,9.51,9.51,0,0,0-4.91-1c-1.69,0-3.38.28-5.07.28-2.68,0-8.75-.75-11.16-1.94,0,1.3.45,3.4,1.35,4.34-1.74-.32-3.29-1.85-4.68-2.95-.24,1.62,1.42,5.24,2.78,6.14-2.35-.23-2.78,3.83,1.23,3.83C342.12,244.36,354.3,251.21,360.13,246.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.78,233.84l-2.19,3.8,2.16.8A44.12,44.12,0,0,1,338.78,233.84Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.36,226.74a30.37,30.37,0,0,0-1.58,7.1,45,45,0,0,0,.72,11,7,7,0,0,0,1.27,3.22,5,5,0,0,0,3.49,1.61,15.26,15.26,0,0,0,3.92-.38v6.23c4.73,1.11,8.64,1.6,12.34-1.25l-.39-8a11.68,11.68,0,0,1-6.65-1.05c-3.26-1.76-4.18-4.58-3.72-6.15a2.47,2.47,0,0,0,2.55.9,3.41,3.41,0,0,0,2.12-1.69,6.74,6.74,0,0,0,.79-2.65,4.8,4.8,0,0,0-.48-3.28,3.43,3.43,0,0,0-3.7-1.24,5.26,5.26,0,0,0-3.11,2.6,9.89,9.89,0,0,0-.55,1.19.74.74,0,0,1-1.43-.18,9.84,9.84,0,0,1,.94-5.21,3.94,3.94,0,0,1-1.75.4,2.2,2.2,0,0,1-1.67-.77,1.5,1.5,0,0,1-.06-1.77A3.72,3.72,0,0,1,340.36,226.74Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.19,297.29c.54-13.24,3.36-23,3.18-28-.3-8.1-1.29-17.22-13.84-15.39l-13.35,1.3-6.78,1.65L331,276.44,330.48,302l-.37,21.76c10.88,4.56,20.42,5.59,27.75,4.92.61-3.48,1.55-8,2.16-11.53.58,3.31,1.2,6.63,1.8,9.94,6.46-1.19,10.26-2.64,11.21-4.76C372.61,316.05,370.86,305.52,371.19,297.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.51,269.14l-3.52,7.3L330.48,302l0,1c3.08-6.24,8.29-17.45,9.73-24.62Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.36,286.86l-5-3.78a1.8,1.8,0,0,0-2.1-.07l-.59.39-2.55,1.34a3.61,3.61,0,0,0-1.38,1.25l-1.44,2.21a5.25,5.25,0,0,0-.66,4.26l.06.2,1.65-2.25c3.14,3.22,9.66,1.36,9.66,1.36Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.4,256.9h0a16.27,16.27,0,0,0-12.72,11.24l-6.49,21.05-13.84-3c-5.56.49-4.73,7.73-4.73,7.73l17.59,7.7a7,7,0,0,0,9-3.06l11-20.25C343.31,269.31,340.4,256.9,340.4,256.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.19,289.19c-2.44,1.93-3.07,5.68-3.07,5.68-1.93-2.75-.63-5.61.5-6.24Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.18,255.25l.63-3c5.71-1.63,13.29-1.42,13.29-1.42l.95,2.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.59,239.38l2.64-1.16,2.36,1.69a1,1,0,0,1,.28,1.32h0a1,1,0,0,1-1.33.4l-1.58-.81,1.23,1.45a1.61,1.61,0,0,1,0,2.09l-2.57,3a1.73,1.73,0,0,1-2.31.3l-1.63-1.14-1.28,1.73-.14-.31a4.44,4.44,0,0,1,.86-5Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--svgid--inject-2",
    d: "M348.28,238.32h0l-3.53-4h0l.42.47.43.5.46.51.46.53.46.53.45.51.44.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.53,234.93l3.53,4a3.47,3.47,0,0,0-.78-.63,4,4,0,0,0-3.18-.25l-3.53-4a4,4,0,0,1,3.18.25,3,3,0,0,1,.78.63",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--svgid--inject-2",
    d: "M345.53,234.93l3.53,4a4,4,0,0,1-.2,5l-3.53-4A4,4,0,0,0,345.53,234.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.53,234.93l3.53,4a.27.27,0,0,0,.07.08l-3.53-4a.27.27,0,0,1-.07-.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.6,235l3.53,4,.17.23-3.53-4-.17-.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.77,235.24l3.53,4,.15.25-3.53-4-.15-.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.92,235.49l3.53,4c.05.1.09.19.13.29l-3.53-4c0-.1-.08-.19-.13-.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.05,235.78l3.53,4a2.19,2.19,0,0,1,.12.33l-3.53-4a2.19,2.19,0,0,0-.12-.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.17,236.11l3.53,4a3.34,3.34,0,0,1,.1.43l-3.53-4a3.34,3.34,0,0,0-.1-.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.27,236.54l3.53,4a3.82,3.82,0,0,1,0,.68l-3.53-4a3.82,3.82,0,0,0,0-.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.31,237.22l3.53,4a4.27,4.27,0,0,1-.22,1.25l-3.53-4a4.27,4.27,0,0,0,.22-1.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.09,238.47l3.53,4a4.88,4.88,0,0,1-.28.68l-3.53-4a4.88,4.88,0,0,0,.28-.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.81,239.15l3.53,4a3.83,3.83,0,0,1-.25.44l-3.53-4a3.83,3.83,0,0,0,.25-.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.56,239.59l3.53,4a4,4,0,0,1-.23.34l-3.53-4a4,4,0,0,0,.23-.34",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.52,50.62c3.93-2.27,7.25-1.16,8.3,2.36a11.65,11.65,0,0,1,4.25-4.72c3.07-1.78,5.58-.35,5.59,3.19v1.62l4.14-2.38c2.15-1.25,3.91-.25,3.91,2.23a8.56,8.56,0,0,1-3.89,6.74l-35,20.21c-2.15,1.25-3.91.25-3.92-2.23a8.58,8.58,0,0,1,3.9-6.74l4.13-2.39v-3C89.9,60,93.75,53.37,98.52,50.62Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.83,63.86c2.82-1.63,5.2-.83,6,1.7a8.32,8.32,0,0,1,3-3.39c2.21-1.28,4-.25,4,2.28v1.17l3-1.71c1.54-.9,2.8-.18,2.81,1.6a6.18,6.18,0,0,1-2.8,4.84L123.71,84.86c-1.55.89-2.81.17-2.82-1.6a6.2,6.2,0,0,1,2.8-4.85l3-1.71V74.56A13.58,13.58,0,0,1,132.83,63.86Z",
    style: {
      fill: "#e6e6e6"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevops2);
export default __webpack_public_path__ + "static/media/devops2.4bf43fb3b4007747deba8385ff795162.svg";
export { ForwardRef as ReactComponent };